// import library
import React from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router";
import { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import moment from "moment";
// import files
import { env } from "../../env";
import { AuthContext } from "../../context";
import { logEvent } from "../../analytics";
// common components
import Layout from "../../layouts/Layout";
import Pagination from "../../components/Common/Table/Pagination";
import AddQuantityButton from "../../components/Common/Table/AddQuantityButton";
import RemoveQuantityButton from "../../components/Common/Table/RemoveQuantityButton";
import SortItem from "../../components/Common/Order/SortItem";
import DateInputField from "../../components/Common/InputField/DateInputField";
import LoaderIcon from "../../components/Common/Icon/Loader";
import SearchBar from "../../components/Common/Table/SearchBar";
import SortData from "../../components/Common/Table/SortData";
import FilterFormLayout from "../../components/Common/Table/FilterFormLayout";
import TableLoaderIcon from "../../components/Common/Icon/TableLoader";
import CartBox from "../../components/Common/CreateOrder/CartBox";
import VirtualCartBox from "../../components/Common/CreateOrder/VirtualCart";
import MessageLink from "../../components/Common/Table/MessageLink";
import CategoryCheckbox from "../../components/Common/InputField/CategoryCheckbox";
import ProductGroupCheckbox from "../../components/Common/InputField/ProductGroupCheckbox";
import FilterDataHover from "../../components/Common/Table/FilterDataHover";
import MobilePagination from "../../components/Common/Table/MobilePagination";
import CategorySubcategoryFilter from "../../components/Common/CreateOrder/CategorySubcategoryFilter";
import { NavLink } from "react-router-dom";
import CartLoaderIcon from "../../components/Common/Icon/CartLoader";
import CategoryScrollFilter from "../../components/Common/CreateOrder/CategoryScrollFilter";
import CommonCategoryScrollFilter from "../../components/Common/CreateOrder/CommonCategoryScrollFilter";

const OrderAgain = () => {
    // variables
    const { t } = useTranslation();
    const navigate = useNavigate();
    const today = dayjs();
    const authContext = useContext(AuthContext);
    const dropdownRef = useRef(null);
    const dropdownRef1 = useRef(null);
    const dropdownRef2 = useRef(null);
    const {id, customerid} = useParams();
    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    // local store
    const coTab = localStorage.getItem('co_tab');
    // loader
    const [isLoader, setIsLoader] = useState(true);
    const [isTableLoader, setIsTableLoader] = useState(false);
    const [isMadeForYouLoader, setIsMadeForYouLoader] = useState(false);
    const [isCommonTableLoader, setIsCommonTableLoader] = useState(false);
    // static data
    const activeTab = "border-b border-blue-normal text-blue-normal";
    const weekDaysGr = ['Σάββατο', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'];
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const sortTypesList = [
        {
            "name" : "product name - top to bottom",
            "field" : "productname",
            "type" : "asc"
        },
        {
            "name" : "product name - bottom to top",
            "field" : "productname",
            "type" : "desc"
        },
        {
            "name" : "product code - top to bottom",
            "field" : "code",
            "type" : "asc"
        },
        {
            "name" : "product code - bottom to top",
            "field" : "code",
            "type" : "desc"
        },
        {
            "name" : "product price - top to bottom",
            "field" : "price",
            "type" : "asc"
        },
        {
            "name" : "product price - bottom to top",
            "field" : "price",
            "type" : "desc"
        },
        {
            "name" : "product m/m - top to bottom",
            "field" : "unit",
            "type" : "asc"
        },
        {
            "name" : "product m/m - bottom to top",
            "field" : "unit",
            "type" : "desc"
        },
    ];
    const [orderSeriesLastNumber, setOrderSeriesLastNumber] = useState(0);
    const [inputs, setInputs] = useState({
        orderSeries: 1,
        orderSeriesDescription : "Πώληση Ροής",
        productTypeDescription : "all",
        productTypeId: 0,
        couponCode: "",
        items: [],
        filteredItems: []
    });
    const [filterInputs, setFilterInputs] = useState({
        productCode: "",
        description: "",
        categoryIdArray: "",
        categoryNameArray: "",
        subCategoryIdArray: "",
        masterCategoryIdArray: "",
        productGroupIdArray: "",
        productGroupNameArray: ""
    });
    // data
    const [comment, setComment] = useState("");
    const [showTab, setShowTab] = useState(coTab ? coTab : 'cart');
    const [workingDays, setWorkingDays] = useState([]);
    // store data
    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [customerData, setCustomerData] = useState({});
    const [categoryListOne, setCategoryListOne] = useState([]);
    const [productGroupList, setProductGroupList] = useState([]);
    const [categoryListTwo, setCategoryListTwo] = useState([]);
    const [filterCategoryList, setFilterCategoryList] = useState([]);
    const [madeForYouSectionList, setMadeForYouSectionList] = useState([]);
    const [calculateApiCart, setCalculateApiCart] = useState([]);
    const [productStaticQuantity, setProductStaticQuantity] = useState([]);
    const [productStaticMessage, setProductStaticMessage] = useState([]);
    const [orderSeries, setOrderSeries] = useState([]);
    const [disbaleWeeks, setDisableWeeks] = useState([]);
    const [currentDate, setCurrentDate] = useState(today);
    const [ipData, setIpData] = useState({});
    const [shippingCost, setShippingCost] = useState(0);
    const [isBundleLoading, setIsBundleLoading] = useState(0);
    const [isCartLoader, setIsCartLoader] = useState(false);
    
    const [commonItems, setCommonItems] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });
    const [products, setProducts] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });

    // handle
    const [calculateButton, setCalculateButton] = useState(false);
    const [showSortOne, setShowSortOne] = useState(false);
    const [showCategoryOne, setShowCategoryOne] = useState(false);
    const [showProductGroupOne, setShowProductGroupOne] = useState(false);
    const [showFilterOne, setShowFilterOne] = useState(false);
    const [showFilterTwo, setShowFilterTwo] = useState(false);
    const [showCategoryTwo, setShowCategoryTwo] = useState(false);
    const [showProductGroupTwo, setShowProductGroupTwo] = useState(false);
    const [showSortTwo, setShowSortTwo] = useState(false);
    const [showPaymentMethod, setShowPaymentMethod] = useState(false);
    const [showCalculating, setShowCalculating] = useState(false);
    const [formButton, setFormButton] = useState(false);
    const [isCalculate, setIsCalculate] =  useState(false);
    const [reCalculate, setReCalculate] = useState(false);
    // table
    const [rowCurrentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(30);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortType, setSortType] = useState("");
    const [sortName, setSortName] = useState("");
    const [rowCommonItemsCurrentPage, setCommonItemsCurrentPage] = useState(1);
    const [rowsCommonItemsPerPage, setCommonItemsRowsPerPage] = useState(30);
    const [sortCommonItemsField, setCommonItemsSortField] = useState("");
    const [sortCommonItemsType, setCommonItemsSortType] = useState("");
    const [sortCommonItemsName, setCommonItemsSortName] = useState("");
    const [firstLevelCategoryList, setFirstLevelCategoryList] = useState([]);
    const [secondLevelCategoryList, setSecondLevelCategoryList] = useState([]);
    const [thirdLevelCategoryList, setThirdLevelCategoryList] = useState([]);
    const [firstCommonLevelCategoryList, setFirstCommonLevelCategoryList] = useState([]);
    const [secondCommonLevelCategoryList, setSecondCommonLevelCategoryList] = useState([]);
    const [thirdCommonLevelCategoryList, setThirdCommonLevelCategoryList] = useState([]);
    // other
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [paymentTypeId, setPaymentTypeId] = useState("");
    const [deliveryDate, setDeliveryDate] = useState("");
    const [defaultDeliveryDate, setDefaultDeliveryDate] = useState("");
    const [calculateJson, setCalculateJson] = useState([]);
    const [cartProductCode, setCartProductCode] = useState([]);
    const [calculatedItems, setCalculateItems] = useState([]);
    const [filterCalculateItems , setFilterCalculateItems] = useState([]);
    // cart
    const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
    const [cartItemsData, setCartItemsData] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "totalPoints" : 0,
        "totalInitialPrice" : 0,
    });
    const [virtualCartItems, setVirtualCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "totalTaxes": 0
    });
    const [calculateCartItems, setCalculateCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "totalTaxes": 0
    });
    const [finalCartItems, setFinalCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "discount" : 0,
        "transportationFee" : 0,
        "totalPoints" : 0,
        "totalTaxes": 0
    });

    const handlePageChange = () => { 
        if (inputs?.items?.length > 0) {
            Swal.fire({
                title: `${t("are you sure")}?`,
                text: `${t("if you click yes, you will lose all the data of the order, the cart will be reset")}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${t('yes')}`,
                cancelButtonText: `${t('no')}`
            }).then((result) => {
                if (result.isConfirmed) {
                    clearCartStorage();
                    navigate('/order/history');
                } else {
                    window.history.pushState(null, "", window.location.pathname); // Stay on page
                }
            });
            return;
        }
    
        navigate('/order/history');
    };
        
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowPaymentMethod(false)
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
                setShowFilterOne(false);
                setShowFilterTwo(false);
                setShowCategoryOne(false);
                setShowProductGroupOne(false);
                setShowCategoryTwo(false);
                setShowProductGroupTwo(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef2.current && !dropdownRef2.current.contains(event.target)) {
                setShowSortOne(false);
                setShowSortTwo(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            window.history.pushState(null, "", window.location.pathname); // Prevent direct back navigation
            handlePageChange(); // Call function to handle logic
        };
    
        window.history.pushState(null, "", window.location.pathname); // Set initial state
        window.addEventListener("popstate", handlePopState);
    
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [inputs]);
        
    // functions
    useEffect(() => {
        const requestDataOne = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": rowCommonItemsCurrentPage,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        }; 
        const requestDataTwo = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": rowCurrentPage,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        }; 
    
        const fetchData = async () => {
            try {
                if (id) {
                    await Promise.all([
                        getDefaultProductImage(baseUrl, token),
                        getCustomerDataApi(baseUrl, token),
                        getOrderData(baseUrl, token),
                        getCompanyErpRelationsList(baseUrl, token),
                        getFirstLevelCategory(baseUrl, token),
                        getFirstCommonLevelCategory(baseUrl, token),
                        getCategoryList(baseUrl, token, inputs.productTypeId),
                        getProductGroupA(baseUrl, token),
                        getPaymentTypeList(baseUrl, token),
                        getDeliveryWeeks(baseUrl, token),
                    ]);
    
                    setIsLoader(false);
                    if(showTab === 'summary') {
                        setShippingCost(localStorage.getItem("co_shipping"));
                        setShowTab("cart");
                    }

                    getCommonItems(baseUrl, token, requestDataOne);
                    getMadeForYouSectionList(baseUrl, token);
                    getProductListApi(baseUrl, token, requestDataTwo);
                }
            } catch (error) {
                setIsLoader(false); // Stop loader even if error occurs
                console.error("Error fetching data", error);
            }
        };
        fetchData();

    }, [id, baseUrl, token]);
    const workingDaysString = workingDays.join(", ");

    // api's
    const getOrderData = async (url, token) => {
        const headers = {
            "Accept": "Application/json",
            "Content-Type": "Application/json",
            "Authorization": `Bearer ${token}`
        };
    
        try {
            // Fetch customer order details
            const response = await axios.get(`${url}/api/Product/GetCustomerOrderDetail?orderid=${id}`, { headers });
    
            if (!response.data.success) {
                const itemsArray = [];
                let linenum = 1;
                let calculateArrayJson = [];
                let productCodeArray = [];
                let staticQuantityArray = {};
                let staticMessageArray = {};
    
                // Process each product in the order details
                for (const value of response.data.details) {
                    if (!value.iscalculateditem) {
                        try {
                            // Fetch product details
                            const productResponse = await axios.get(`${baseUrl}/api/Product/GetProductDetail?productid=${value.productid}&customerid=${response.data.customerID}`, { headers });
                            if (productResponse.data[0]) {
                                const exists = itemsArray.some(item => item.id === value.productid);

                                if (!exists && value.qty !== 0) {
                                    const array = {
                                        "action": "add",
                                        "id": value.productid,
                                        "message": "",
                                        "product": productResponse.data[0],
                                        "quantity": value.qty,
                                        "suggestQty": ""
                                    };
        
                                    // Get extra taxes asynchronously
                                    const taxResponse = await getProductExtraTaxes(value.productid);
                                    const extraTaxes = taxResponse?.nettaxvalue || 0;
                                    array.product.extra_taxes = extraTaxes;
        
                                    // Add the product to the items array
                                    itemsArray.push(array);
        
                                    const productLines = {
                                        "LINENUM": linenum,
                                        "vat_code": productResponse.data[0].tab_1_name || 0,
                                        "MU": productResponse.data[0].baseUnitOfMeasure || "",
                                        "item_code": productResponse.data[0].item_code,
                                        "QTY1": value.qty,
                                        "UnitPrice": productResponse.data[0].productprice || 0,
                                        "discount_pct": productResponse.data[0].discount || 0,
                                        "product_name": productResponse.data[0].productname,
                                        "vat_percent": productResponse.data[0].vat_percentage || 0
                                    };
        
                                    linenum++;
                                    calculateArrayJson.push(productLines);
                                    productCodeArray.push(value.product_code);
                                    staticQuantityArray[value.product_code] = value.qty;
                                    staticMessageArray[value.product_code] = "";
                                }
                            }
                        } catch (error) {
                            console.log("Error fetching product data:", error);
                        }
                    }
                }
    
                // Update state after all items are processed
                setInputs({
                    ...inputs,
                    'items': itemsArray,
                    'filteredItems': itemsArray
                });
                setProductStaticQuantity(staticQuantityArray);
                setProductStaticMessage(staticMessageArray);
                setCartProductCode(productCodeArray);
                setCalculateJson(calculateArrayJson);
                calculateSummary(itemsArray);
            } else {
                Swal.fire({
                    title: `${t("warning")}!`,
                    text: `${t("something went wrong")}!`,
                    icon: "warning",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "ok"
                });
                navigate('/order/history');
            }
        } catch (error) {
            console.log("Error fetching order data:", error);
            if (error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        }
    };

    // same as create
    const getOrderSeriesList = async (url, token, partnerid) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Customer/GetOrderSeriesListsPartnerWise?partnerid=${partnerid}`, { headers })
        .then((response) => {
            if(response.data && response.data.success !== '0') {
                setOrderSeries(response.data);
                response.data.map((value, index) => {
                    if(value.orderseriesid == 1) {
                        setOrderSeriesLastNumber(value.orderseries_lastnumber);
                    }
                });
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getIpJson = async () => {
        axios.get("https://ipapi.co/json/", { headers : {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
        }})
        .then((response) => {
            setIpData(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCustomerDataApi = async (url, token) => {
        axios.post(url + "/api/Customer/GetCustomerDetail", { customerid: customerid }, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if (response.data.length > 0) {
                const momentCurrentDate = moment();
                axios.get(baseUrl+`/api/Customer/GetCustomerDeliveryWorkingHoursData?customerid=${customerid}`, { headers : {
                    "Accept" : "Application/json",
                    "Content-Type" : "Application/json",
                    "Authorization" : `Bearer ${token}`
                }})
                .then((response1) => {
                    if(response1.data.data.week) {
                        const inputTime = response1.data.data.time;
                        const inputWeek = response1.data.data.week;
                        const dayNumber = momentCurrentDate.day();

                        if (inputWeek.includes(7)) {
                            inputWeek[inputWeek.indexOf(7)] = 0;
                        }

                        const localizedWorkingDays = inputWeek.map(day => weekDaysGr[day]);
                        setWorkingDays(localizedWorkingDays);

                        if (inputWeek.includes(dayNumber)) {
                            const d1 = momentCurrentDate.format("YYYY-MM-DD HH:mm:ss");
                            if(inputTime) {
                                const formattedInputTime = convertTo24HourFormat(inputTime);
                                var d2 = momentCurrentDate.format(`YYYY-MM-DD ${formattedInputTime}`);
                            } else {
                                var d2 = momentCurrentDate.format(`YYYY-MM-DD 04:00:00`);
                            }

                            if (moment(d1).isAfter(d2)) {
                                for (let i = 1; i <= 7; i++) {
                                    const newDate = moment().clone().add(i, "days");
                                    if (inputWeek.includes(newDate.day())) {
                                        setCurrentDate(today.add(1, 'day'));
                                        setDeliveryDate(newDate.format("YYYY-MM-DD"));
                                        setDefaultDeliveryDate(newDate.format("YYYY-MM-DD"));
                                        break;
                                    }
                                }
                            } else {
                                setCurrentDate(today);
                                setDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                                setDefaultDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                            }
                        } else {
                            for (let i = 1; i <= 7; i++) {
                                const newDate = moment().clone().add(i, "days");
                                if (inputWeek.includes(newDate.day())) {
                                    setCurrentDate(today.add(1, 'day'));
                                    setDeliveryDate(newDate.format("YYYY-MM-DD"));
                                    setDefaultDeliveryDate(newDate.format("YYYY-MM-DD"));
                                    break;
                                }
                            }
                        }
                    } else {
                        const inputWeek = [1, 2, 3, 4, 5, 6];
                        const localizedWorkingDays = inputWeek.map(day => weekDaysGr[day]);
                        setWorkingDays(localizedWorkingDays);
                        var d1 = momentCurrentDate.format("YYYY-MM-DD HH:mm:ss");
                        var d2 = momentCurrentDate.format(`YYYY-MM-DD 04:00:00`);
                        if (moment(d1).isAfter(d2)) {
                            const newDate = momentCurrentDate.add(1, "days");
                            setCurrentDate(today.add(1, 'day'));
                            setDeliveryDate(newDate.format("YYYY-MM-DD"));
                            setDefaultDeliveryDate(newDate.format("YYYY-MM-DD"));
                        } else {
                            setCurrentDate(today);
                            setDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                            setDefaultDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
                
                setCustomerData(response.data[0]);
                setPaymentMethod(response.data[0].paymenttype);
                setPaymentTypeId(response.data[0].paymenttypeid);

                getOrderSeriesList(baseUrl, token, response.data[0].partnerid);
                getIpJson();

                // if(!localStorage.getItem('co_tab') && response.data[0].showcommon) {
                //     setShowTab('common-items')
                // }
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        })
    };
    const getDefaultProductImage = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/User/GetDefaultImage",{ headers })
        .then((response) => {
            setDefaultProductImage(response.data.productDefaultImage);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getCompanyErpRelationsList = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/OfflineSync/GetCompanyErpRelationsList", { headers })
        .then((response) => {
            if(response.data.length > 0 && response.data[0].iscalculationmandatory) {
                if(response.data[0].iscalculationmandatory === "1") {
                    setIsCalculate(true);
                } else {
                    setIsCalculate(false);
                    setCalculateButton(true);
                }
            } else {
                setCalculateButton(true);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCategoryList = async (url, token, productId) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetProductCategoryList?customerid=${customerid}&producttypeid=0`, { headers })
        .then((response) => {
            if(response.data && response.data.success !== '0') {
                setCategoryListOne(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });

        await axios.get(url+`/api/Product/GetProductCategoryList?customerid=${customerid}&producttypeid=${productId}`, { headers })
        .then((response) => {
            if(response.data && response.data.success !== '0') {
                setCategoryListTwo(response.data);
            }
            axios.get(url+`/api/OfflineSync/GetProductSubCategories`, { headers })
            .then((response1) => {
                if(response.data && response.data.success !== '0') {
                    const categorizedData = response.data.map(category => ({
                        ...category,
                        subcategories: response1.data
                            .filter(sub => sub.categoryid === category.categoryid)
                            .map(({ subcategoryid, subcategoryname, ordering }) => ({
                                subcategoryid, subcategoryname, ordering
                            }))
                    }));
                    setFilterCategoryList(categorizedData);
                }
            }).catch((error) => {
                console.log(error);
            })
        }).catch((error) => {
            console.log(error);
        });
    };
    const getProductGroupA = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/OfflineSync/GetProductGroupAList`, { headers })
        .then((response) => {
            setProductGroupList(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getPaymentTypeList = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetPaymentTypeListForB2B?customerid=${customerid}`, { headers })
        .then((response) => {
            setPaymentMethods(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getDeliveryWeeks = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Customer/GetCustomerDeliveryWorkingHoursData?customerid=${customerid}`, { headers })
        .then((response) => {
            if(response.data.data.week) {
                const week = [1, 2, 3, 4, 5, 6, 7];
                const disableWeek = [];
                week.map((value) => {
                    if(!response.data.data.week.includes(value)) {
                        disableWeek.push(value);
                    }
                });

                if(disableWeek.includes(7)) {
                    disableWeek.map((value, index) => {
                        if(value === 7) {
                            disableWeek[index] = 0;
                        }
                    })
                }
                setDisableWeeks(disableWeek);
            } else {
                setDisableWeeks([0]); 
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCommonItems = async (url, token, data) => {
        setIsCommonTableLoader(true);
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+`/api/Product/GetCommonItemsList`, data, { headers })
        .then((response) => {
            setCommonItems(response.data);
            setIsCommonTableLoader(false);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getMadeForYouSectionList = async (url, token) => {
        setIsMadeForYouLoader(true);
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/MadeForYouList?customerid=${customerid}`, { headers })
        .then((response) => {
            setMadeForYouSectionList(response.data);
            setIsMadeForYouLoader(false);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getProductListApi = async (url, token, data) => {
        setIsTableLoader(true);
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+"/api/Product/GetProductList", data, { headers })
        .then((response) => {
            setProducts(response.data);
            setIsTableLoader(false);
        }).catch((error) => {
            console.log(error);
        });
    };
    const sendCartProduct = async (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        
        await axios.post(baseUrl+`/api/Product/SaveCartTrackingDetails`, data, { headers })
        .then((response) => {
            if(!response.data.success) {
                console.log(response);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getProductExtraTaxes = async (cartProductId) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
    
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
    
        try {
            const response = await axios.get(baseUrl + `/api/Product/GetProductExtraTaxes?productid=${cartProductId}`, { headers });
            return response.data?.[0];
        } catch (error) {
            console.error("Error fetching cart details:", error);
            return null;
        }
    };
    const getCalculateShippingCost = async () => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
    
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        var currentdate = new Date(); 
        var datetime = currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();
        const localDate = new Date(currentdate.getTime() - currentdate.getTimezoneOffset() * 60000);
        const localISOString = localDate.toISOString();

        const items = [];
        inputs.filteredItems.map((item, index) => {
            const productPrice = item.product.productprice;
            const productVat = Number(item.product.vaT_Value);
            const productTax = Number(item.product.extra_taxes);
            const productQuantity = item.quantity;
            const productTotalNetValue = productQuantity *  productPrice;
            const productTotalVat = productQuantity * productVat;
            const productTotalTax = productQuantity * productTax;
            const productTotalAmount = productTotalNetValue + productTotalVat + productTotalTax;
            const productTotalDiscount = item.product.discount_amount;

            items.push(
                {
                    OrderDetailID: 0,
                    discount_amount: 0,
                    init_price: (productPrice).toFixed(2),
                    percent_discount: productTotalDiscount,
                    points: 0,
                    product_id: item.id,
                    product_code: item.product.item_code,
                    quantity: (productQuantity).toFixed(2),
                    serial_no: 0,
                    sub_total: (productTotalNetValue).toFixed(2),
                    total: (productTotalAmount).toFixed(2),
                    vat_amount: productTotalVat,
                    free_qty: 0,
                    Netamount: (productTotalNetValue).toFixed(2),
                    discount_amount1: 0,
                    discount_amount2: 0,
                    discount_amount3: 0,
                    discount_amount4: 0,
                    discount_amount5: 0,
                    totalDiscount_amount: 0,
                    discount_pct1: 0,
                    discount_pct2: 0,
                    discount_pct3: 0,
                    discount_pct4: 0,
                    discount_pct5: 0,
                    listpriceamount: 0,
                    customerdicountpct: 0,
                    priceamount: (productPrice).toFixed(2),
                    stock_qty: 0,
                    unit_cost: 0,
                    StockDetailID: 0,
                    iscalculateditem: false,
                    extra_taxes: productTotalTax
                }
            )
        });

        var totalAmount = finalCartItems.totalAmount;
        var netAmount = finalCartItems.netAmount;
        var totalQuantity = finalCartItems.totalQuantity;
        var totalPoints = finalCartItems.totalPoints;
        var vats = finalCartItems.vats;
        var totalTaxes = finalCartItems.totalTaxes;
        var totalDiscountAmount = finalCartItems.discountAmount;
        var totalDiscountPercentage = finalCartItems.discountPercentage;

        let bodyRequest = {
            OrderID: 0,
            BankID: "",
            ChequeExpiryDate: "",
            ChequeNo: "",
            CustomerID: parseInt(customerid),
            customerAddressID: 0,
            customerAddressCode: "",
            Mobile_App_Version12: "",
            Mobile_User_Mac_Address: "",
            PaymentDate: "",
            PaymentType: paymentMethod,
            PaymentTypeID: paymentTypeId,
            total_tax_amount: totalTaxes,
            comment: comment,
            delivery_date: moment(deliveryDate).format("DD-MM-YYYY"),
            discount_amount: totalDiscountAmount,
            final_amount: totalAmount,
            orderCode: "",
            percent_discount: totalDiscountPercentage,
            sub_total: netAmount,
            tid: "",
            total_ChargeProduct: 0,
            total_gift_quantity: 0,
            total_pieces: totalQuantity,
            total_points: totalPoints,
            total_transportation: 0,
            transactionDate: "",
            transactionId: "",
            vat_amount: vats,
            Discount_Redeem_Product_ID: 0,
            total_free_qty: 0,
            Order_status: "Draft",
            StockOrderID: 0,
            StartTime: datetime, 
            EndTime: datetime, 
            Latitude: "",
            Longitude: "",
            newTotalPointBalance: 0,
            OrderSeriesID: inputs.orderSeries,
            OrderSeriesNumber:  orderSeriesLastNumber + 1,
            CourierTransactionID: 0,
            iscalculated: false,
            create_order: true,
            items: items,
            order_date: localISOString
        };

        try {
            const response = await axios.post(baseUrl + `/api/Product/CalculateShippingCost`, bodyRequest, { headers });
            const shipCost = response.data[0].shippingcost || 0;
            setShippingCost(shipCost);
            localStorage.setItem("co_shipping", shipCost);
            return response.data; 
        } catch (error) {
            console.error("Error fetching cart details:", error);
            return null;
        }
    };
    const getFirstLevelCategory = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetFirstLevelCategory?customerid=${customerid}`, { headers })
        .then((response) => {
            if(response.data) {
                setFirstLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getSecondLevelCategory = async (data) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(baseUrl+`/api/Product/GetSecondLevelCategory?customerid=${customerid}&mastercategoryids=${data.masterCategoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setSecondLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getThirdLevelCategory = async (data) => {
        const headers = {
            "Accept": "Application/json",
            "Content-Type": "Application/json",
            "Authorization": `Bearer ${token}`
        };

        await axios.get(baseUrl + `/api/Product/GetThirdLevelCategory?customerid=${customerid}&categoryids=${data.categoryIds?.toString() || ""}&mastercategoryids=${data.masterCategoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setThirdLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getFirstCommonLevelCategory = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetFirstLevelCategoryForCommonItems?customerid=${customerid}`, { headers })
        .then((response) => {
            if(response.data) {
                setFirstCommonLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getSecondCommonLevelCategory = async (data) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(baseUrl+`/api/Product/GetSecondLevelCategoryForCommonItems?customerid=${customerid}&mastercategoryids=${data.masterCategoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setSecondCommonLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getThirdCommonLevelCategory = async (data) => {
        const headers = {
            "Accept": "Application/json",
            "Content-Type": "Application/json",
            "Authorization": `Bearer ${token}`
        };
        await axios.get(baseUrl + `/api/Product/GetThirdLevelCategoryForCommonItems?customerid=${customerid}&categoryids=${data.categoryIds?.toString() || ""}&mastercategoryids=${data.masterCategoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setThirdCommonLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    // functions
    const openTab = (e, value) => {
        if(value === 'summary') {
            getCalculateShippingCost();
        }
        setShowTab(value);
        localStorage.setItem('co_tab', value);
    };
    const convertTo24HourFormat = (timeString) => { 
        const [time, period] = timeString.split(" ");
        const [hour, minute] = time.split(":");
        let formattedHour = parseInt(hour, 10);
    
        if (period === "PM" && formattedHour !== 12) {
            formattedHour += 12;
        } else if (period === "AM" && formattedHour === 12) {
            formattedHour = 0;
        }
    
        return `${formattedHour < 10 ? "0" : ""}${formattedHour}:${minute}:00`;
    };
    const handleTabCheckDataFromChild = (data) => {
        if(inputs.items.length > 0 && data.tab === 'order') {
            Swal.fire({
                title: `${ t("are you sure")}?`,
                text: `${ t("if you click yes, you will lost all the data of the order, the cart will be reset")}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t('yes')}`,
                cancelButtonText: `${ t('no')}`
            }).then((result) => {
                if (result.isConfirmed) {
                    if(data.link === '/logout') {
                        authContext.logout();
                    } else {
                        navigate(data.link);
                    }
                    clearCartStorage();
                }
            });
        } else {
            if(data.link === '/logout') {
                authContext.logout();
                clearCartStorage();
            } else {
                navigate(data.link);
            }
        }
    };
    const clearCartStorage = () => {
        localStorage.removeItem('co_tab');
        localStorage.removeItem('co_coupon');
        localStorage.removeItem('co_comment');
        localStorage.removeItem('co_method');
        localStorage.removeItem('co_id');
        localStorage.removeItem('co_quantity');
        localStorage.removeItem('co_qty_message');
        localStorage.removeItem('co_items');
        localStorage.removeItem('co_calculate');
        localStorage.removeItem('co_code');
        localStorage.removeItem('co_calculate_json');
        localStorage.removeItem('co_calculate_button');
        localStorage.removeItem('co_calculate_filter');
        localStorage.removeItem("intercool_cartData");
        localStorage.removeItem("intercool_productCodes");
        localStorage.removeItem("intercool_staticQuantities");
        localStorage.removeItem("co_shipping");
        setCalculateJson([]);
        setCartProductCode([]);
        setProductStaticQuantity([]);
    };
    const clearData = () => {
        setFormButton(false);
        setShowFilterOne(false);
        setShowFilterTwo(false);
        setShowProductGroupOne(false);
        setShowProductGroupTwo(false);
        setReCalculate(false);
        setProductStaticQuantity([]);
        setProductStaticMessage([]);
        setComment("");
        setShowTab('common-items');
        setDeliveryDate(defaultDeliveryDate);
        // if(customerData.showcommon) {
        //     setShowTab('common-items')
        // } else {
        //     setShowTab('product-list')
        // }

        setInputs({
            ...inputs,
            orderSeries: "",
            orderSeriesDescription : "",
            productTypeDescription : "all",
            productTypeId: 0,
            couponCode: "",
            items: [],
            filteredItems: []
        });
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getOrderSeriesList(baseUrl, token, customerData.partnerid);

        setCartItemsData({
            ...cartItemsData,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "totalPoints" : 0,
            "totalInitialPrice" : 0
        });

        setVirtualCartItems({
            ...virtualCartItems,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "netAmount" : 0,
            "vats" : 0,
            "totalAmount" : 0,
            "totalPoints" : 0,
            "totalTaxes": 0
        });

        setCalculateCartItems({
            ...calculateCartItems,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "netAmount" : 0,
            "vats" : 0,
            "totalAmount" : 0,
            "totalTaxes": 0
        });

        setFinalCartItems({
            ...finalCartItems,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "netAmount" : 0,
            "vats" : 0,
            "totalAmount" : 0,
            "discount" : 0,
            "transportationFee" : 0,
            "totalPoints" : 0,
            "totalTaxes": 0
        });
    };
    const handleClearData = (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to clear")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                logEvent('create_order_page', 'create_order', 'filter', 'clear-filter');
                clearData();
                clearCartStorage();
            }
        });
    };
    const openPaymentMethod = (e) => {
        e.preventDefault();
        setShowPaymentMethod(!showPaymentMethod);
    };
    const handlePaymentMethod = (e, value) => {
        e.preventDefault();
        setShowPaymentMethod(!showPaymentMethod);
        setPaymentMethod(value.name);
        setPaymentTypeId(value.id);
        localStorage.setItem('co_method', value.name);
        localStorage.setItem('co_id', value.id);
    };
    const handleDateDataFromChild = (data) => {
        setDeliveryDate(data);
    };
    const handleCommentChange = (e) => {
        setComment(e.target.value);
        logEvent('create_order_page', 'cart', 'comment', e.target.value);
    };
    const handleApplyCouponCode = async (e) => {
        e.preventDefault();
        if(inputs.couponCode.trim().length > 0) {
            Swal.fire({
                position: "center",
                icon: "success",
                title: `${ t("coupon code applied")}!`,
                showConfirmButton: false,
                timer: 1500
            });
        }
    };
    const handleCouponCodeChange = (e) => {
        e.preventDefault();

        setInputs({
            ...inputs,
            [e.target.name]: e.target.value,
        });
        localStorage.setItem('co_coupon',  e.target.value);
        logEvent('create_order_page', 'cart', 'coupon', e.target.value);
    };
    // common filter show
    const handleCommonSearchDataFromChild = (data) => {
        setIsCommonTableLoader(true);
        setIsTableLoader(true);

        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });

        setCommonItemsCurrentPage(1);
        setSearchTerm(data);
        setCurrentPage(1);

        // Base requestData object with common properties
        let requestCommonData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": data,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };
        // Base requestData object with common properties
        let requestProductData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": data,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };

        // Conditional updates based on sort field and type
        if (sortCommonItemsField === 'productname') {
            requestCommonData.productname_asc = sortCommonItemsType === 'asc';
            requestCommonData.productname_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'price') {
            requestCommonData.price_asc = sortCommonItemsType === 'asc';
            requestCommonData.price_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'unit') {
            requestCommonData.mm_asc = sortCommonItemsType === 'asc';
            requestCommonData.mm_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'point') {
            requestCommonData.points_asc = sortCommonItemsType === 'asc';
            requestCommonData.points_desc = sortCommonItemsType === 'desc';
        }

        // Conditional updates based on sort field and type
        if (sortField === 'productname') {
            requestProductData.productname_asc = sortType === 'asc';
            requestProductData.productname_desc = sortType === 'desc';
        } else if (sortField === 'price') {
            requestProductData.price_asc = sortType === 'asc';
            requestProductData.price_desc = sortType === 'desc';
        } else if (sortField === 'unit') {
            requestProductData.mm_asc = sortType === 'asc';
            requestProductData.mm_desc = sortType === 'desc';
        } else if (sortField === 'point') {
            requestProductData.points_asc = sortType === 'asc';
            requestProductData.points_desc = sortType === 'desc';
        }

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        getCommonItems(baseUrl, token, requestCommonData);
        getProductListApi(baseUrl, token, requestProductData);
        logEvent('create_order_page', 'common-items', 'search', data);
        logEvent('create_order_page', 'product-list', 'search', data);
    };
    const handleShowSort = (e, list) => {
        if(list === 'one') {
            setShowSortOne(!showSortOne); 
            setShowFilterOne(false);
        } else if (list === 'two') {
            setShowSortTwo(!showSortTwo); 
            setShowFilterTwo(false);
        }
    };
    const handleShowFilter = (e, list) => {
        if(list === 'one') {
            setShowFilterOne(!showFilterOne);
            setShowSortOne(false);  
        } else if (list === 'two') {
            setShowFilterTwo(!showFilterTwo); 
            setShowSortTwo(false); 
        }
    };
    const handleShowCategory = (e, list) => {
        if(list === 'one') {
            setShowCategoryOne(!showCategoryOne)
            setShowProductGroupOne(false);  
        } else if (list === 'two') {
            setShowCategoryTwo(!showCategoryTwo)
            setShowProductGroupTwo(false); 
        }
    };
    const handleShowProductGroup = (e, list) => {
        if(list === 'one') {
            setShowProductGroupOne(!showProductGroupOne)
            setShowCategoryOne(false);  
        } else if (list === 'two') {
            setShowProductGroupTwo(!showProductGroupTwo)
            setShowCategoryTwo(false); 
        }
    };
    const handleChange = (e) => {
        e.preventDefault();
        setFilterInputs({
            ...filterInputs,
            [e.target.name]: e.target.value,
        });
    };
    const handleCategoryDataFromChild = (data) => {
        setFilterInputs({
            ...filterInputs,
            'categoryIdArray' : data.id.toString(),
            'categoryNameArray' : data.name.toString()
        });
    };
    const handleProductGroupDataFromChild = (data) => {
        setFilterInputs({
            ...filterInputs,
            'productGroupIdArray' : data.id.toString(),
            'productGroupNameArray' : data.name.toString()
        });
    };
    const handleFilterSubmit = (e) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        setIsCommonTableLoader(true);
        setIsTableLoader(true);

        setShowFilterOne(false);
        setShowProductGroupOne(false);
        setShowCategoryOne(false);
        setShowFilterTwo(false);
        setShowProductGroupTwo(false);
        setShowCategoryTwo(false);

        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCurrentPage(1);
        setCommonItemsCurrentPage(1);

        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
            
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points',
            code: 'productcode'
        };
        
        if (sortMapping[sortCommonItemsField]) {
            const sortKey = `${sortMapping[sortCommonItemsField]}_${sortCommonItemsType}`;
            requestData[sortKey] = true;
        }
        
        const requestData1 = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        const sortMapping1 = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points',
            code: 'productcode'
        };
        
        if (sortMapping1[sortField]) {
            const sortKey = `${sortMapping1[sortField]}_${sortType}`;
            requestData1[sortKey] = true;
        }
        getCommonItems(baseUrl, token, requestData);
        getProductListApi(baseUrl, token, requestData1);

        // log
        logEvent('create_order_page', 'filter', 'product-list', requestData1);
    };
    const clearFilterData = (e) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        setIsCommonTableLoader(true);
        setIsTableLoader(true);

        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });

        setShowFilterOne(!showFilterOne);
        setShowProductGroupOne(false);
        setShowCategoryOne(false);
        setShowFilterTwo(!showFilterTwo);
        setShowProductGroupTwo(false);
        setShowCategoryTwo(false);

        setThirdLevelCategoryList([]);
        setFilterInputs({
            ...filterInputs,
            'productCode': "",
            'description': "",
            'categoryIdArray': "",
            'categoryNameArray': "",
            'subCategoryIdArray': "",
            'productGroupIdArray': "",
            'productGroupNameArray': "",
        });
        
        const requestData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": "",
            "product_desc_search": "",
            "groupa": "",
            "categoryids": "",
            "subcategoryids": "",
            "mastercategoryids": filterInputs.masterCategoryIdArray
        }; 
        getCommonItems(baseUrl, token, requestData);
            
        const requestData1 = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": "",
            "product_desc_search": "",
            "groupa": "",
            "categoryids": "",
            "subcategoryids": "",
            "mastercategoryids": filterInputs.masterCategoryIdArray
        }; 
        getProductListApi(baseUrl, token, requestData1);

        logEvent('create_order_page', 'filter', 'product-list', 'clear-filter');
    };
    // another filter
    const handleSelectionChange = (data) => {
        const updatedKeyData = {
            masterCategoryids: filterInputs.masterCategoryIdArray.split(","),
            categoryIds: data.categories,
            subCategoryIds: data.subcategories
        }
        setFilterInputs({
            ...filterInputs,
            'categoryIdArray' : data.categories?.toString() || "",
            'categoryNameArray' :  data.categoriesOnly?.toString() || "",
            'subCategoryIdArray' : data.subcategories?.toString() || "",
        });

        if(filterInputs.masterCategoryIdArray) {
            getThirdLevelCategory(updatedKeyData);
            getThirdCommonLevelCategory(updatedKeyData);
        }

        setIsCommonTableLoader(true);
        setIsTableLoader(true);

        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCurrentPage(1);
        setCommonItemsCurrentPage(1);

        let requestCommonData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categories?.toString() || "",
            "subcategoryids": data.subcategories?.toString() || "",
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };

        if (sortCommonItemsField === 'productname') {
            requestCommonData.productname_asc = sortCommonItemsType === 'asc';
            requestCommonData.productname_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'price') {
            requestCommonData.price_asc = sortCommonItemsType === 'asc';
            requestCommonData.price_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'unit') {
            requestCommonData.mm_asc = sortCommonItemsType === 'asc';
            requestCommonData.mm_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'point') {
            requestCommonData.points_asc = sortCommonItemsType === 'asc';
            requestCommonData.points_desc = sortCommonItemsType === 'desc';
        }

        let requestProductData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categories?.toString() || "",
            "subcategoryids": data.subcategories?.toString() || "",
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };

        if (sortField === 'productname') {
            requestProductData.productname_asc = sortType === 'asc';
            requestProductData.productname_desc = sortType === 'desc';
        } else if (sortField === 'price') {
            requestProductData.price_asc = sortType === 'asc';
            requestProductData.price_desc = sortType === 'desc';
        } else if (sortField === 'unit') {
            requestProductData.mm_asc = sortType === 'asc';
            requestProductData.mm_desc = sortType === 'desc';
        } else if (sortField === 'point') {
            requestProductData.points_asc = sortType === 'asc';
            requestProductData.points_desc = sortType === 'desc';
        }

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getCommonItems(baseUrl, token, requestCommonData);
        getProductListApi(baseUrl, token, requestProductData);
    };
    //three level filter
    const handleCommonSecondLevelCategoryList = (data) => {
        setSecondCommonLevelCategoryList(data);
    };
    const handleCommonThirdLevelCategoryList = (data) => {
        setThirdCommonLevelCategoryList(data);
    };
    const handleProductSecondLevelCategoryList = (data) => {
        setSecondLevelCategoryList(data);
    };
    const handleProductThirdLevelCategoryList = (data) => {
        setThirdLevelCategoryList(data);
    };
    const handleFilterDataFromChild = (data) => {
        setIsCommonTableLoader(true);
        setIsTableLoader(true);

        const categoryNames = secondLevelCategoryList
            .filter(c =>  data.categoryIds.includes(c.categoryid))
            .map(c => c.categoryname);

        setFilterInputs({
            ...filterInputs,
            'categoryIdArray' : data.categoryIds?.toString() || "",
            'subCategoryIdArray' : data.subCategoryIds?.toString() || "",
            'masterCategoryIdArray' : data.masterCategoryIds?.toString() || "",
            'categoryNameArray' : categoryNames.toString() || ""
        });

        if(data.type === 'common') {
            getThirdLevelCategory(data);
            getSecondLevelCategory(data);
        } else if (data.type === 'product') {
            getThirdCommonLevelCategory(data);
            getSecondCommonLevelCategory(data);
        }
        
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });

        setCommonItemsCurrentPage(1);
        setCurrentPage(1);

        let requestCommonData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categoryIds?.toString() || "",
            "subcategoryids": data.subCategoryIds?.toString() || "",
            "mastercategoryids": data.masterCategoryIds?.toString() || ""
        };
        if (sortCommonItemsField === 'productname') {
            requestCommonData.productname_asc = sortCommonItemsType === 'asc';
            requestCommonData.productname_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'price') {
            requestCommonData.price_asc = sortCommonItemsType === 'asc';
            requestCommonData.price_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'unit') {
            requestCommonData.mm_asc = sortCommonItemsType === 'asc';
            requestCommonData.mm_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'point') {
            requestCommonData.points_asc = sortCommonItemsType === 'asc';
            requestCommonData.points_desc = sortCommonItemsType === 'desc';
        }

        let requestProductData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categoryIds?.toString() || "",
            "subcategoryids": data.subCategoryIds?.toString() || "",
            "mastercategoryids": data.masterCategoryIds?.toString() || ""
        };
        if (sortField === 'productname') {
            requestProductData.productname_asc = sortType === 'asc';
            requestProductData.productname_desc = sortType === 'desc';
        } else if (sortField === 'price') {
            requestProductData.price_asc = sortType === 'asc';
            requestProductData.price_desc = sortType === 'desc';
        } else if (sortField === 'unit') {
            requestProductData.mm_asc = sortType === 'asc';
            requestProductData.mm_desc = sortType === 'desc';
        } else if (sortField === 'point') {
            requestProductData.points_asc = sortType === 'asc';
            requestProductData.points_desc = sortType === 'desc';
        }

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getCommonItems(baseUrl, token, requestCommonData);
        getProductListApi(baseUrl, token, requestProductData);
    };
    // category
    const handleSortTypeOneDataFromChild = (e, data) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setShowSortOne(!showSortOne); 
        setCommonItemsSortField(data.field);
        setCommonItemsSortType(data.type);
        setCommonItemsCurrentPage(1);
        setCommonItemsSortName(data.name);

        // Create a base request data object that is common across all cases
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map the incoming field to the appropriate sort key prefix.
        // Notice: "unit" maps to "mm" and "code" maps to "productcode".
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            code: 'productcode'
        };
        
        // If the field exists in our mapping, set the correct sort key to true.
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`;
            requestData[sortKey] = true;
        }
        
        // Call the API with the dynamically generated requestData.
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'sort', 'common-items', data);
    };
    const handleCommonItemsSortDataFromChild = (data) => {
        setCommonItemsSortField(data.field);
        setCommonItemsSortType(data.type);
        setCommonItemsSortName(data.field);
        setCommonItemsCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Build the base requestData with all common fields and default sort flags (all false)
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map incoming field names to their corresponding sort key prefixes.
        // Note: "unit" maps to "mm" and "point" maps to "points", and "productname", "price" use the same key.
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points',
            code: 'productcode' // if needed in the future
        };
        
        // If the provided data.field exists in the mapping, build the sort key (like "price_asc")
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`; // e.g., "productname_asc"
            requestData[sortKey] = true;
        }
        
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'common-items', 'sort', data);
    };
    const handleCommonItemsCurrentPage = (page) => {
        setIsCommonTableLoader(true);
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCommonItemsCurrentPage(page);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Build the base requestData with all common fields and default sort flags (all false)
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: page,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Create a mapping for the sort fields to the corresponding key prefixes.
        // For example: "unit" maps to "mm" and "point" maps to "points".
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the provided sortCommonItemsField exists in our mapping,
        // build the sort flag key (e.g. "price_asc" or "productname_desc") and set it to true.
        if (sortMapping[sortCommonItemsField]) {
            const sortKey = `${sortMapping[sortCommonItemsField]}_${sortCommonItemsType}`;
            requestData[sortKey] = true;
        }
        
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'common-items', 'pagination', page);
    };
    const handleCommonItemsPerPage = (row) => {
        setIsCommonTableLoader(true);
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCommonItemsRowsPerPage(row);
        setCommonItemsCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        
        // Build the base requestData with all common fields and sort flags defaulting to false
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: row,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map sort fields to their corresponding sort key prefixes
        // "unit" becomes "mm" and "point" becomes "points"
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the provided sort field exists in our mapping, build the sort flag and set it to true
        if (sortMapping[sortCommonItemsField]) {
            const sortKey = `${sortMapping[sortCommonItemsField]}_${sortCommonItemsType}`; // e.g., "productname_asc"
            requestData[sortKey] = true;
        }
        
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'common-items', 'pagination-per-page', row);
    };
    // product
    const handleSortTypeTwoDataFromChild = (e, data) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setSortField(data.field);
        setSortType(data.type);
        setCurrentPage(1);
        setShowSortTwo(!showSortTwo); 
        setSortName(data.name);

        // Build the base request data object (all sort flags default to false)
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Mapping for data.field values to their corresponding sort key prefix
        // Note: "unit" maps to "mm" and "code" maps to "productcode"
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            code: 'productcode'
        };
        
        // If the field provided is in our mapping, set the correct sort property to true
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`; // e.g., "price_asc"
            requestData[sortKey] = true;
        }
        
        // Call the API with the dynamically built requestData
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'sort', 'product-list', data);
    };
    const handleSortDataFromChild = (data) => {
        setSortField(data.field);
        setSortType(data.type);
        setSortName(data.field);
        setCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Create a base requestData object with all common properties and default sort flags set to false
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map the incoming field to the corresponding sort key prefix.
        // If you ever need to support "unit" or "point", they can be mapped accordingly.
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the field exists in our mapping, build the sort key (e.g. "productname_asc") and set it to true
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`;
            requestData[sortKey] = true;
        }
        
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'product-list', 'sort', data);
    };
    const handleCurrentPage = (page) => {
        setIsTableLoader(true);
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCurrentPage(page);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Build the base requestData object with common fields and default sort flags set to false.
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: page,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map sort fields to the corresponding sort key prefix.
        // "unit" maps to "mm" and "point" maps to "points" if needed.
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the sort field exists in our mapping, build the sort key (e.g. "productname_asc") and set it to true.
        if (sortMapping[sortField]) {
            const sortKey = `${sortMapping[sortField]}_${sortType}`;
            requestData[sortKey] = true;
        }
    
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'product-list', 'pagination', page);
    };
    const handlePerPage = (row) => {
        setIsTableLoader(true);
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setRowsPerPage(row);
        setCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Create a base request object with common properties and all sort flags set to false.
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: row,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Create a mapping from sort field names to their corresponding property key prefixes.
        // (If your API ever supports additional fields like "unit" or "point", add them here.)
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the sort field exists in our mapping, build the sort key dynamically.
        // For example, if sortField is "productname" and sortType is "asc", the key becomes "productname_asc".
        if (sortMapping[sortField]) {
            const sortKey = `${sortMapping[sortField]}_${sortType}`;
            requestData[sortKey] = true;
        }
        
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'product-list', 'pagination_per_page', row);
    };
    // add product to cart
    const handleQuantityDataFromChild = async (data) => {
        const itemsArray = inputs.items;
        const foundId = itemsArray.some(el => el.id === data.id);

        // get taxes
        if(data.product !== 'remove') {
            setIsBundleLoading(data.id);
            setIsCartLoader(true);
            const taxResponse = await getProductExtraTaxes(data.id);
            const extraTaxes = taxResponse?.nettaxvalue || 0;
            data.product.extra_taxes = extraTaxes;
        }

        if (!foundId) {
            itemsArray.push(data);
        } else {
            if(data.product !== 'remove') {
                itemsArray.map((obj, index) => {
                    if (obj.id === data.id) {
                        if(data.quantity === 0) {
                            itemsArray.splice(index, 1);
                        } else {
                            obj.quantity = data.quantity ;
                            obj.suggestQty = data.suggestQty;
                            obj.message = data.message;
                        }
                    }
                });
            } else {
                itemsArray.map((obj, index) => {
                    if (obj.id === data.id) {
                        itemsArray.splice(index, 1);
                    }
                });
            }
        }

        setInputs({
            ...inputs,
            'items' : itemsArray,
            'filteredItems' : itemsArray
        });
        calculateSummary(itemsArray);
        if(isCalculate) {
            setCalculateButton(false);
        }

        const calculateArrayJson = [];
        const productCodeArray = [];
        const staticQuantityArray = {};
        const staticMessageArray = {};

        let linenum = 1;
        itemsArray.map((value, index) => {
            if(value.quantity > 0 && value.quantity !== NaN) {
                var productLines = {
                    "LINENUM": linenum,
                    "vat_code": value.product.tab_1_name ? value.product.tab_1_name : 0 ,
                    "MU": value.product.baseUnitOfMeasure ? value.product.baseUnitOfMeasure : "",
                    "item_code": value.product.item_code,
                    "QTY1": value.quantity,
                    "UnitPrice": value.product.productprice ? value.product.productprice : 0,
                    "discount_pct": value.product.discount ? value.product.discount : 0,
                    "product_name": value.product.productname,
                    "vat_percent": value.product.vat_percentage ? value.product.vat_percentage : 0 
                }
                linenum++;
                calculateArrayJson.push(productLines);
                productCodeArray.push(value.product.item_code);
                staticQuantityArray[value.product.item_code] = value.quantity;
                staticMessageArray[value.product.item_code] = value.message;
            }
        });

        setProductStaticQuantity(staticQuantityArray);
        setProductStaticMessage(staticMessageArray);
        setCartProductCode(productCodeArray);
        setCalculateJson(calculateArrayJson);
        setCalculateItems([]);
        setFilterCalculateItems([]);
        setIsCartLoader(false);

        if(data.action === 'add') {
            Swal.fire({
                position: "center",
                icon: "success",
                title:  `${ t("product added")}!`,
                showConfirmButton: false,
                timer: 1500
            });
        }
        setIsBundleLoading(0);
    };
    const calculateSummary = (itemsArray) => {
        let newtotalQuantity = 0;
        let newtotalVat = 0;
        let newtotalNetValue = 0;
        let newtotalPoints = 0;
        let newTotalTaxes = 0;
        let newTotalDiscountPercentage = 0;
        let newTotalDiscountAmount = 0;

        itemsArray.map((obj, index) => {
            const quantity = obj.quantity;
            const price = obj.product.productprice;
            const vat = Number(obj.product.vaT_Value);
            const taxes = obj.product.extra_taxes;
            const point = obj.product.loyalty_point;
            const discountPercentage = obj.product?.discount || 0;
            const discountAmount = Number(obj.product?.discount_amount) || 0;
            const amount = price * quantity;

            newtotalQuantity += parseFloat(quantity.toFixed(2));
            newtotalNetValue += parseFloat(amount.toFixed(2));
            newtotalVat += parseFloat((vat * quantity).toFixed(2));
            newTotalDiscountPercentage += discountPercentage;
            newTotalDiscountAmount += discountAmount;
            newTotalTaxes += (taxes * quantity);
            newtotalPoints += (point * quantity);
        });

        let newFinalTotalQuantity = parseFloat(newtotalQuantity.toFixed(2));
        let newFinalTotalPoints = newtotalPoints;
        let newFinalTotalVat = parseFloat(newtotalVat.toFixed(2));
        let newFinalTotalNetValue = parseFloat(newtotalNetValue.toFixed(2));
        let newFinalTotalTaxes = newTotalTaxes;
        let finalFinalTotalPrice = newFinalTotalVat + newFinalTotalNetValue + newFinalTotalTaxes; 

        setCartItemsData({
            ...cartItemsData,
            "itemsCount" : itemsArray.length,
            "totalQuantity" : newFinalTotalQuantity,
            "totalPoints" : newFinalTotalPoints,
            "totalInitialPrice" : newFinalTotalNetValue,
            "totalTaxes" : newFinalTotalTaxes
        });

        setVirtualCartItems({
            ...virtualCartItems,
            "itemsCount" : itemsArray.length,
            "totalQuantity" : newFinalTotalQuantity,
            "netAmount" : newFinalTotalNetValue,
            "vats" : newFinalTotalVat,
            "totalAmount" : finalFinalTotalPrice,
            "totalPoints" : newFinalTotalPoints,
            "totalTaxes" : newFinalTotalTaxes,
            "discountPercentage" : newTotalDiscountPercentage,
            "discountAmount" : newTotalDiscountAmount
        });

        setFinalCartItems({
            ...finalCartItems,
            "itemsCount" : itemsArray.length,
            "totalQuantity" : newFinalTotalQuantity,
            "netAmount" : newFinalTotalNetValue,
            "vats" : newFinalTotalVat,
            "totalAmount" : finalFinalTotalPrice,
            "discount" : 0,
            "transportationFee" : 0,
            "totalPoints" : 0,
            "totalTaxes" : newFinalTotalTaxes,
            "discountPercentage" : newTotalDiscountPercentage,
            "discountAmount" : newTotalDiscountAmount
        });
    };
    const calculateItemsAmount = async (e) => {
        e.preventDefault();
        setShowCalculating(true);
        setReCalculate(true);

        setCalculateItems([]);
        setFilterCalculateItems([]);
        
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        const calculateData = {
            "customer": {
                "customer_code": customerData.code,
                "document_date": deliveryDate,
                "payment_type": "",
                "DATA": {
                    "PRODUCTLINES": calculateJson
                }
            }
        }

        logEvent('create_order_page', 'cart', 'calculate-cart', calculateData);
        await axios.post(baseUrl+"/api/edi/SvcQuotation", calculateData, { headers })
        .then((response) => {
            if(response.data.success) {
                const staticQuantityArray = {};
                let resData = response.data.data.MTRLINES;
                let totalDiscountAmount = 0;

                if (resData.length > 0) {
                    const updatedItems = inputs.filteredItems.map(item => {
                        const value = resData.find(val => val.MTRL_MTRL_CODE === item.product.item_code);
                
                        if (value) {
                            const productName = value.MTRL_MTRL_NAME;
                            const productCode = value.MTRL_MTRL_CODE;
                            const quantity = Number(value.QTY);
                            const price = Number(value.NETLINEVAL);
                            const vat = Number(value.VATAMNT);
                            const tax = Number(value.EXPVAL);
                            const totalDiscount = Number(value.LDISC1VAL) + Number(value.LDISC2VAL) + Number(value.LDISC3VAL);
                            totalDiscountAmount += totalDiscount;
                            staticQuantityArray[item.product.item_code] = quantity;

                            return {
                                ...item,
                                product: {
                                    ...item.product,
                                    productname: productName, 
                                    item_code: productCode,
                                    productprice: (price / quantity),
                                    vaT_Value: (vat / quantity),
                                    extra_taxes: (tax / quantity),
                                },
                                quantity: quantity
                            };
                        }
                    });
                    setProductStaticQuantity(staticQuantityArray);
                    setInputs({
                        ...inputs,
                        filteredItems: updatedItems,
                    });
                    calculateSummary(updatedItems);
                    setTotalDiscountAmount(totalDiscountAmount);

                    localStorage.setItem('co_quantity', JSON.stringify(staticQuantityArray));
                    localStorage.setItem('co_items', JSON.stringify(updatedItems));
                }
            } else {
                setCalculateApiCart([]);
            }
            setShowCalculating(false);
            setCalculateButton(true);
        }).catch((error) => {
            console.log(error);
            setShowCalculating(false);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleLinkDataFromChild = (data) => {
        let itemCheck = inputs.items;
        itemCheck.map((value, index) => {
            if(value.product.item_code === data) {
                value.quantity = value.suggestQty;
            }
        })
        const itemsArray = inputs.items;

        setInputs({
            ...inputs,
            'items' : itemsArray,
            'filteredItems' : itemsArray
        });
        calculateSummary(itemsArray);
        if(isCalculate) {
            setCalculateButton(false);
        }

        const calculateArrayJson = [];
        const productCodeArray = [];
        const staticQuantityArray = {};
        const staticMessageArray = {};

        let linenum = 1;
        itemsArray.map((value, index) => {
            if(value.quantity > 0 && value.quantity !== NaN) {
                var productLines = {
                    "LINENUM": linenum,
                    "vat_code": value.product.tab_1_name,
                    "MU": value.product.baseUnitOfMeasure ? value.product.baseUnitOfMeasure : 0,
                    "item_code": value.product.item_code,
                    "QTY1": value.quantity,
                    "UnitPrice": value.product.productprice,
                    "discount_pct": value.product.discount ? value.product.discount : 0,
                    "product_name": value.product.productname,
                    "vat_percent": value.product.vat_percentage
                }
                linenum++;
                calculateArrayJson.push(productLines);
                productCodeArray.push(value.product.item_code);
                staticQuantityArray[value.product.item_code] = value.quantity;
                if(data !== value.product.item_code) {
                    staticMessageArray[value.product.item_code] = value.message;
                }
            }
        });

        setProductStaticQuantity(staticQuantityArray);
        setProductStaticMessage(staticMessageArray);
        setCartProductCode(productCodeArray);
        setCalculateJson(calculateArrayJson);
        setCalculateItems([]);
        setFilterCalculateItems([]);
    };
    // submit
    const validateValues = (inputValues) => {
        let errors = {};

        if (inputValues.items.length === 0) {
            errors.items = true;
        }
        return errors;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        await getOrderSeriesList(baseUrl, token, customerData.partnerid);

        if (Object.keys(validateValues(inputs)).length === 0 && deliveryDate.length > 0 && paymentMethod.trim().length > 0) {
            Swal.fire({
                title: `${ t("are you sure")}?`,
                text: `${ t("you want to create new order")}!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t("yes")}!`,
                cancelButtonText: `${ t("cancel")}!`
            }).then((result) => {
                if (result.isConfirmed) {
                    setFormButton(true);
                    var currentdate = new Date(); 
                    var datetime = currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();
                    const localDate = new Date(currentdate.getTime() - currentdate.getTimezoneOffset() * 60000);
                    const localISOString = localDate.toISOString();

                    const baseUrl = env.REACT_APP_API_URL;
                    const token = localStorage.getItem('token');
                    const headers = {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`
                    };

                    const items = [];
                    const requestData = [];
                    inputs.filteredItems.map((item, index) => {
                        const productPrice = item.product.productprice;
                        const productVat = Number(item.product.vaT_Value);
                        const productTax = Number(item.product.extra_taxes);
                        const productQuantity = item.quantity;
                        const productTotalNetValue = productQuantity * productPrice;
                        const productTotalVat = productQuantity * productVat;
                        const productTotalTax = productQuantity * productTax;
                        const productTotalAmount = productTotalNetValue + productTotalVat + productTotalTax;
                        const productTotalDiscount = item.product.discount_amount;

                        items.push(
                            {
                                OrderDetailID: 0,
                                discount_amount: 0,
                                init_price: (productPrice).toFixed(2),
                                percent_discount: productTotalDiscount,
                                points: 0,
                                product_id: item.id,
                                product_code: item.product.item_code,
                                quantity: (productQuantity).toFixed(2),
                                serial_no: 0,
                                sub_total: (productTotalNetValue).toFixed(2),
                                total: (productTotalAmount).toFixed(2),
                                vat_amount: productTotalVat,
                                free_qty: 0,
                                Netamount: (productTotalNetValue).toFixed(2),
                                discount_amount1: 0,
                                discount_amount2: 0,
                                discount_amount3: 0,
                                discount_amount4: 0,
                                discount_amount5: 0,
                                totalDiscount_amount: 0,
                                discount_pct1: 0,
                                discount_pct2: 0,
                                discount_pct3: 0,
                                discount_pct4: 0,
                                discount_pct5: 0,
                                listpriceamount: 0,
                                customerdicountpct: 0,
                                priceamount: (productPrice).toFixed(2),
                                stock_qty: 0,
                                unit_cost: 0,
                                StockDetailID: 0,
                                iscalculateditem: false,
                                extra_taxes: productTotalTax
                            }
                        )
                    });

                    var totalAmount = finalCartItems.totalAmount;
                    var netAmount = finalCartItems.netAmount;
                    var totalQuantity = finalCartItems.totalQuantity;
                    var totalPoints = finalCartItems.totalPoints;
                    var vats = finalCartItems.vats;
                    var totalTaxes = finalCartItems.totalTaxes;
                    var totalDiscountAmount = finalCartItems.discountAmount;
                    var totalDiscountPercentage = finalCartItems.discountPercentage;

                    items.map((item, index) => {
                        requestData.push({
                            "customerID": customerid,
                            "productID": item.product_id,
                            "qty":  item.quantity,
                            "latGPS": ipData.latitude,
                            "longGPS": ipData.longitude,
                            "deviceID": ipData.ip,
                            "productPrice": item.init_price,
                            "discountPercent": item.percent_discount,
                            "type": "add",
                            "screen": "b2b",
                            "couriertransactionid": 0,
                        });
                    })
                    sendCartProduct(requestData);

                    let data = {
                        OrderID: 0,
                        BankID: "",
                        ChequeExpiryDate: "",
                        ChequeNo: "",
                        CustomerID: parseInt(customerid),
                        customerAddressID: 0,
                        customerAddressCode: "",
                        Mobile_App_Version12: "",
                        Mobile_User_Mac_Address: "",
                        PaymentDate: "",
                        PaymentType: paymentMethod,
                        PaymentTypeID: paymentTypeId,
                        total_tax_amount: totalTaxes,
                        comment: comment,
                        delivery_date: moment(deliveryDate).format("DD-MM-YYYY"),
                        discount_amount: totalDiscountAmount,
                        final_amount: (totalAmount + shippingCost),
                        orderCode: "",
                        percent_discount: totalDiscountPercentage,
                        sub_total: netAmount,
                        tid: "",
                        total_ChargeProduct: 0,
                        total_gift_quantity: 0,
                        total_pieces: totalQuantity,
                        total_points: totalPoints,
                        total_transportation: shippingCost,
                        transactionDate: "",
                        transactionId: "",
                        vat_amount: vats,
                        Discount_Redeem_Product_ID: 0,
                        total_free_qty: 0,
                        Order_status: "Draft",
                        StockOrderID: 0,
                        StartTime: datetime, 
                        EndTime: datetime, 
                        Latitude: "",
                        Longitude: "",
                        newTotalPointBalance: 0,
                        OrderSeriesID: inputs.orderSeries,
                        OrderSeriesNumber: orderSeriesLastNumber + 1,
                        CourierTransactionID: 0,
                        iscalculated: false,
                        create_order: true,
                        items: items,
                        order_date: localISOString
                    };

                    if(customerData.minimumcharge > 0 && customerData.minimumcharge > totalAmount) {
                        Swal.fire({
                            title: `${ t("warning")}!`,
                            text: `${ t("order total value can not be less than") + " "+ customerData.minimumcharge}!`,
                            icon: "warning"
                        });
                        setFormButton(false);
                        logEvent('create_order_page', 'cart', 'place_order', 'failed_min_order');
                    } else {
                        axios.post(baseUrl+"/api/Product/PlaceOrder", data, { headers })
                        .then((response) => {
                            if(response.data.success === "1") {
                                logEvent('create_order_page', 'cart', 'place_order', 'success_id_'+response.data.orderID);
                                clearData();
                                clearCartStorage();
                                Swal.fire({
                                    title: `${ t("order created")}!`,
                                    text: `${ t("your order is added with the number") + " "+ response.data.orderID}!`,
                                    icon: "success"
                                });
                                setFormButton(false);
                                navigate('/order/history');
                            } else {
                                Swal.fire({
                                    title: `${ t("oops")}!`,
                                    text: `${ t("something went wrong")}!`,
                                    icon: "warning",
                                });
                                setFormButton(false);
                            }
                        }).catch((error) => {
                            setFormButton(false);
                            Swal.fire({
                                title: `${ t("oops")}!`,
                                text: `${ t("something went wrong")}!`,
                                icon: "warning",
                            });
                        });
                    }
                }
            });
        }
    };

    return (
        <div className="relative">
            <Layout sendTabCheckDataFromChild={handleTabCheckDataFromChild}> 
                <div className="space-y-2 sm:space-y-4">
                    {/* first box */}
                    <div className="sm:flex sm:justify-between sm:items-center">
                        <div>
                            <h1 className="sm:text-2xl font-semibold capitalize">{ t('create order') }</h1>
                            <p className="text-light-400 text-xs sm:text-sm capitalize"><NavLink to="/order/history" >{ t('orders') }</NavLink> / <NavLink to={`/order/history/${id}`} >{ t('order detail') }</NavLink> / { t('order again') }</p>
                        </div>
                        <div className="mt-2 sm:mt-0 flex items-center justify-end space-x-2">
                            <div>
                                <button onClick={(e) => handleClearData(e)} className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('clear')}</button>
                            </div>
                        </div>
                    </div>
                    { isLoader 
                        ? 
                            <LoaderIcon /> 
                        :
                            <div className={(showTab === 'product-list' || showTab === 'common-items') ? "space-y-2" : "space-y-2 sm:space-y-4"}>
                                {/* first box */}
                                <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-4 shadow-around">
                                    <div className="grid lg:grid-cols-7 space-y-4 lg:space-y-0">
                                        <div className={ (showTab === 'order-type' || showTab === 'common-items' || showTab === 'made-for-you' || showTab === 'product-list') ? " lg:col-span-3 " : " lg:col-span-2 " + " flex flex-col justify-between min-h-20"}>
                                            <div>
                                                <h1 className="font-semibold lg:text-lg">{customerData.name}</h1>
                                            </div>
                                            <div className="font-normal text-xs lg:text-sm text-gray-dark capitalize">
                                                { t('customer code') }: {customerData.code}
                                            </div>
                                            {customerData.address ? 
                                                <div className="flex items-center text-sm">
                                                    <div className="flex">
                                                        <img src="../../../../assets/icons/location.svg" alt="mail" />
                                                        <div className="text-gray-dark ml-1">{customerData.address}</div>
                                                    </div>
                                                </div>
                                                : null
                                            }
                                        </div>
                                        <div className={ (showTab === 'order-type' || showTab === 'common-items' || showTab === 'made-for-you' || showTab === 'product-list') ? " lg:col-span-4 " : " lg:col-span-5 "}>
                                            { (showTab === 'order-type' || showTab === 'common-items' || showTab === 'made-for-you' || showTab === 'product-list') ? <CartBox cartItemsData={cartItemsData} /> : <VirtualCartBox finalCartItems={finalCartItems} /> }
                                        </div>
                                    </div>
                                    <div className="flex justify-between md:justify-normal space-x-3 md:space-x-6 overflow-auto no-scrollbar">
                                        <div onClick={(e) => openTab(e, 'common-items')} className={(showTab === "common-items" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('common items') }</span></div>
                                        <div onClick={(e) => openTab(e, 'made-for-you')} className={(showTab === "made-for-you" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('made for you') }</span></div>
                                        <div onClick={(e) => openTab(e, 'product-list')} className={(showTab === "product-list" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('products list') }</span></div>
                                        <div onClick={inputs.items.length > 0 ? (e) => openTab(e, 'cart') : null} className={(showTab === "cart" ? activeTab : "text-gray-dark") + (inputs.items.length === 0 ? " cursor-not-allowed " : " cursor-pointer ")  + " text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('cart') }</span></div>
                                        <div onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={(showTab === "summary" ? activeTab : "text-gray-dark") + (((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? " cursor-pointer " : " cursor-not-allowed ") + " text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('summary') }</span></div>
                                    </div>
                                </div>
                                {/* second box of tab data */}
                                <div>
                                    {(showTab === 'common-items') &&
                                        <div className="space-y-2">
                                            {(firstCommonLevelCategoryList.length > 0) && <CommonCategoryScrollFilter firstCategoryList={firstCommonLevelCategoryList} secondCategoryList={secondCommonLevelCategoryList} thirdCategoryList={thirdCommonLevelCategoryList} sendSecondLevelCategoryList={handleCommonSecondLevelCategoryList} sendThirdLevelCategoryList={handleCommonThirdLevelCategoryList} filterSelected={filterInputs} sendFilterDataFromChild={handleFilterDataFromChild} />}
                                            <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-2 sm:space-y-4 shadow-around">
                                                <div className="xl:flex xl:justify-between xl:items-center xl:space-x-2 space-y-2 xl:space-y-0">
                                                    <SearchBar placeholder={t("search")+"..."} term={searchTerm} setSearchDataFromChild={handleCommonSearchDataFromChild}/>
                                                    <div className="sm:flex sm:items-center sm:space-x-2 space-y-2 sm:space-y-0">
                                                        <CategorySubcategoryFilter filterCategoryList={filterCategoryList} filterSelectedData={filterInputs} onSelectionChange={handleSelectionChange} />
                                                        <div className="flex items-center justify-end space-x-2">
                                                            {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                                <div className="relative flex sm:hidden flex-col items-center group">
                                                                    <div className="border border-blue-normal rounded-xl cursor-pointer bg-white py-1.5 px-2">
                                                                        <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                    </div>
                                                                    <FilterDataHover filter={filterInputs} />
                                                                </div>
                                                            : null}
                                                            <div ref={dropdownRef2} className="relative"> 
                                                                <div className="sm:hidden flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e, 'one')}>
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/sort.svg" alt="sort" />
                                                                </div>
                                                                {
                                                                    showSortOne
                                                                    ?
                                                                        <ul className="z-20 py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-52 text-left h-40 overflow-y-auto no-scrollbar">
                                                                            {sortTypesList.map((value, index) => (
                                                                                <li key={index} onClick={(e) => handleSortTypeOneDataFromChild((e), value)} className={(sortCommonItemsName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                                                            ))}
                                                                        </ul>
                                                                    : null
                                                                }
                                                            </div>
                                                            <div ref={dropdownRef1} className="relative">
                                                                <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-3 sm:py-2 px-4" onClick={(e) => handleShowFilter(e, 'one')}>
                                                                    <img className="w-4" src="../../../../assets/icons/table/filter.svg" alt="filter" />
                                                                    <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                                                </div>
                                                                {
                                                                    showFilterOne
                                                                    ?
                                                                        <FilterFormLayout>
                                                                            <form onSubmit={(e) => handleFilterSubmit(e)}>
                                                                                <div className="px-2 sm:px-4 space-y-2 sm:space-y-4">
                                                                                    <div>
                                                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('product category')}</label>
                                                                                        <div className="inline-block relative w-full mt-1">
                                                                                            <button type="button" onClick={(e) => handleShowCategory(e, 'one')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                                <span className="text-gray-dark capitalize mr-1 text-xs sm:text-sm">{filterInputs.categoryIdArray.length > 0 ? t('filter is applied') : t('select category')}</span>
                                                                                                <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                            </button>
                                                                                            {
                                                                                                showCategoryOne
                                                                                                ? 
                                                                                                    <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-30 text-background-dark bg-white shadow-md rounded-md">
                                                                                                        <CategoryCheckbox parentData={filterInputs.categoryIdArray} categoryList={categoryListOne} sendCategoryDataFromChild={handleCategoryDataFromChild}/>
                                                                                                    </ul>                            
                                                                                                : null
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('product group a')}</label>
                                                                                        <div className="inline-block relative w-full mt-1">
                                                                                            <button type="button" onClick={(e) => handleShowProductGroup(e, 'one')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                                <span className="text-gray-dark capitalize mr-1 text-xs sm:text-sm">{filterInputs.productGroupIdArray.length > 0 ? t('filter is applied') : t('select product group')}</span>
                                                                                                <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                            </button>
                                                                                            {
                                                                                                showProductGroupOne
                                                                                                ? 
                                                                                                    <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-20 text-background-dark bg-white shadow-md rounded-md">
                                                                                                        <ProductGroupCheckbox parentData={filterInputs.productGroupIdArray} productGroupList={productGroupList} sendProductGroupDataFromChild={handleProductGroupDataFromChild}/>
                                                                                                    </ul>                            
                                                                                                : null
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('product code')}</label>
                                                                                        <div className="inline-block relative w-full mt-1">
                                                                                            <input type="text" name="productCode" value={filterInputs.productCode} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("product code")} />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('description')}</label>
                                                                                        <div className="inline-block relative w-full mt-1">
                                                                                            <textarea type="text" name="description" value={filterInputs.description} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("description")} >{filterInputs.description}</textarea>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="flex items-center justify-end my-2">
                                                                                        <div>
                                                                                            <button onClick={(e) => clearFilterData(e)} type="button" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                                                        </div>
                                                                                        <div className="ml-4">
                                                                                            <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </form>
                                                                        </FilterFormLayout>
                                                                    : null
                                                                }
                                                            </div>
                                                            {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                                <div className="relative hidden sm:flex flex-col items-center group">
                                                                    <div className="border border-blue-normal rounded-xl cursor-pointer bg-white p-2 ml-2">
                                                                        <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                    </div>
                                                                    <FilterDataHover filter={filterInputs} />
                                                                </div>
                                                            : null}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* table */}
                                                <div className="sm:block hidden mt-4 relative overflow-x-auto shadow-md rounded-lg">
                                                    <table className="w-full text-xs">
                                                        <thead className="text-gray-normal bg-background-normal">
                                                            <tr>
                                                                <th scope="col" className="font-normal p-4">
                                                                    <div className="flex">
                                                                        <div className="mr-2 uppercase">
                                                                            { t('product name')}
                                                                        </div>
                                                                        <SortData fieldName={'productname'} sortNameData={sortCommonItemsName} sortTypeData={sortCommonItemsType} setSortDataFromChild={handleCommonItemsSortDataFromChild} />
                                                                    </div>
                                                                </th>
                                                                <th scope="col" className="font-normal p-4">
                                                                    <div className="flex">
                                                                        <div className="mr-2 uppercase">
                                                                            { t('price')}
                                                                        </div>
                                                                        <SortData fieldName={'price'} sortNameData={sortCommonItemsName} sortTypeData={sortCommonItemsType} setSortDataFromChild={handleCommonItemsSortDataFromChild} />
                                                                    </div>
                                                                </th>
                                                                <th scope="col" className="font-normal p-4">
                                                                    <div className="flex">
                                                                        <div className="mr-2 uppercase">
                                                                            { t('m/m')}
                                                                        </div>
                                                                        <SortData fieldName={'unit'} sortNameData={sortCommonItemsName} sortTypeData={sortCommonItemsType} setSortDataFromChild={handleCommonItemsSortDataFromChild} />
                                                                    </div>
                                                                </th>
                                                                <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                    { t('add item')}
                                                                </th>
                                                                <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                    { t('message')}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {commonItems.list.length > 0 && commonItems.list.map((row, index) => (
                                                            <tr key={'common'+index} className="bg-white border-b hover:bg-gray-50">
                                                                <td className="py-4 px-2 font-semibold w-[45%]">
                                                                    <div className="flex">
                                                                        <div className="w-14 lg:w-auto">
                                                                            <img className="w-8 h-8" src={row.b2bline4 ? row.b2bline4 : defaultProductImage} alt="product-img" />
                                                                        </div>
                                                                        <div className="ml-2 grid justify-between">
                                                                            <h1 className="lg:text-base tracking-wider">{row.b2bline1}</h1>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline2}</div>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline3}</div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="py-4 px-2 text-light-400">
                                                                    {formatter.format(row.productprice)} €
                                                                </td>
                                                                <td className="py-4 px-2 text-light-400">
                                                                    {row.baseUnitOfMeasure ? row.baseUnitOfMeasure : 'NA'}
                                                                </td>
                                                                <td className="py-4 px-2 flex w-52 sm:flex-col sm:items-center sm:justify-center lg:flex-row">
                                                                    <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                </td>
                                                                <td className="py-4 px-2 text-light-400">
                                                                    <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                    {isCommonTableLoader ? <TableLoaderIcon /> :  
                                                        ((commonItems.list.length > 0) ?
                                                            <Pagination
                                                                currentPage={rowCommonItemsCurrentPage}
                                                                totalCount={commonItems.total_record}
                                                                pageSize={rowsCommonItemsPerPage}
                                                                perPageCount={commonItems.list.length}
                                                                onPageChange={page => handleCommonItemsCurrentPage(page)}
                                                                onPageSizeChange={row => handleCommonItemsPerPage(row)}
                                                            />
                                                            : 
                                                            <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize flex flex-col items-center justify-center">
                                                                <img className="mb-2" src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                                { t('no records available')}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                                                    {(commonItems.list.length > 0) &&
                                                        <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                                            {commonItems.list.map((row, index) => (
                                                                <div key={'common'+index}>
                                                                    <div className="grid space-y-2">
                                                                        <div className="flex">
                                                                            <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={row.b2bline4 ? row.b2bline4 : defaultProductImage} alt="product" />
                                                                            <div className="ml-2 flex flex-col justify-between w-full">
                                                                                <div>
                                                                                    <div className="font-medium text-xs">{row.b2bline1}</div>
                                                                                    <div className="text-light-400 text-[10px] capitalize">{row.b2bline2}</div>
                                                                                    <div className="text-light-400 text-[10px] capitalize">{row.b2bline3}</div>
                                                                                </div>
                                                                                <div className="text-light-400 text-sm text-right">
                                                                                    <span className="capitalize">{ t('price')} : </span><span className="font-medium">{formatter.format(row.productprice)} €</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex justify-between items-center">
                                                                            <div className="text-light-400 text-xs">
                                                                                <div className="uppercase">{ t('m/m')} : </div><div className="font-medium">{row.baseUnitOfMeasure}</div>
                                                                            </div>
                                                                            <div className="flex">
                                                                                <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                            </div>
                                                                        </div>
                                                                        <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                    </div>
                                                                    <div className="my-3 border-t-2 border-background-normal"></div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    }
                                                    {isCommonTableLoader ? <TableLoaderIcon /> : 
                                                        ((commonItems.list.length > 0) 
                                                            ?
                                                                <MobilePagination
                                                                    currentPage={rowCommonItemsCurrentPage}
                                                                    totalCount={commonItems.total_record}
                                                                    pageSize={rowsCommonItemsPerPage}
                                                                    perPageCount={commonItems.list.length}
                                                                    onPageChange={page => handleCommonItemsCurrentPage(page)}
                                                                    onPageSizeChange={row => handleCommonItemsPerPage(row)}
                                                                />
                                                            : 
                                                            <div className="py-4 text-center font-bold text-xs capitalize flex flex-col items-center justify-center">
                                                                <img className="mb-2" src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                                { t('no records available')}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                <div className="flex justify-between sm:justify-end sm:space-x-2">
                                                    <div>
                                                        <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                            { t('cart')}
                                                        </button>
                                                    </div>
                                                    <div>
                                                        <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                            { t('summary')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {(showTab === 'made-for-you') &&
                                        <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-3 shadow-around">
                                            {isMadeForYouLoader ? <TableLoaderIcon /> : madeForYouSectionList.length > 0 ?
                                                madeForYouSectionList.map((section, key1) => (
                                                    <div key={'section'+key1} className="even:bg-white odd:bg-blue-light1">
                                                        <div className="border border-background-normal rounded-[10px] pl-2 sm:pl-4 py-2 sm:py-4 space-y-2 sm:space-y-4">
                                                            <h1 className="capitalize sm:text-lg md:text-3xl font-semibold text-center">{ section.section_title }</h1>
                                                            <p className="first-letter:capitalize text-xs md:text-base font-normal text-center">{ section.section_description }</p>
                                                            <div className="space-y-3 pr-2 sm:pr-4 max-h-[26rem] overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300">
                                                                {(section.products) ? section.products.map((sectionProduct, key2) => (
                                                                    <div key={'sectionProduct'+key2}>
                                                                        <div className="my-3 border-t-2 border-background-normal"></div>
                                                                        <div className="grid sm:grid-cols-3 space-y-2 md:space-y-0">
                                                                            <div className="sm:col-span-2 flex">
                                                                                <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16 sm:w-28 sm:h-28" src={sectionProduct.b2bline4 ? sectionProduct.b2bline4 : defaultProductImage} alt="product" />
                                                                                <div className="ml-2 flex flex-col justify-between">
                                                                                    <div className="font-medium text-sm md:text-lg">{sectionProduct.productname}</div>
                                                                                    <div className="text-light-400 text-xs capitalize">{sectionProduct.productdescription}</div>
                                                                                    <div className="font-bold sm:text-xl text-right sm:text-left">{formatter.format(sectionProduct.productprice)} €</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex justify-between sm:justify-evenly sm:flex-col items-center sm:items-end">
                                                                                <div className="sm:flex sm:items-center sm:space-x-2 text-xs md:text-sm sm:justify-end space-y-1 sm:space-y-0">
                                                                                    <div className="sm:flex border border-black-100 rounded-lg bg-white text-light-400 p-2">
                                                                                        <div className="capitalize">{ t('units')} : </div>
                                                                                        <div className="font-medium">{formatter.format(sectionProduct.quantity_proposed)}</div>
                                                                                    </div>
                                                                                    <div className="sm:flex border border-black-100 rounded-lg bg-white text-light-400 p-2">
                                                                                        <div className="uppercase">{ t('m/m')} : </div>
                                                                                        <div className="font-medium">{sectionProduct.baseUnitOfMeasure}</div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="flex sm:w-52 justify-end">
                                                                                    <AddQuantityButton row={sectionProduct} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[sectionProduct.item_code] ? productStaticQuantity[sectionProduct.item_code] : 0} popCheck={false} type={"box"} loading={isBundleLoading}/>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                                : 
                                                                    <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                                                        { t('no deal available')}
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            : 
                                            <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize flex flex-col items-center justify-center">
                                                <img className="mb-2" src="../../../../assets/icons/no-deal.svg" alt="no-deal" />
                                                { t('no deal available')}
                                            </div>
                                        }
                                        <div className="lg:flex lg:justify-between space-y-2 lg:space-y-0 items-center">
                                            <div className="border border-black-100 rounded-lg bg-white py-2 px-2 text-xs sm:text-sm text-light-400 capitalize sm:w-fit">
                                                <div className="flex divide-x-2 divide-gray-dark divide-solid"> 
                                                    <div className="sm:flex px-1.5 text-light-400 items-center">
                                                        <h1 className="capitalize font-semibold text-xs sm:text-base">{ t('no. of items')}:</h1>
                                                        <div className="font-bold ml-0.5 pt-1 sm:ml-1">{cartItemsData.itemsCount}</div>
                                                    </div>
                                                    <div className="sm:flex px-1.5 text-light-400 items-center">
                                                        <h1 className="capitalize font-semibold text-xs sm:text-base">{ t('total quantity')}:</h1>
                                                        <div className="font-bold ml-0.5 pt-1 sm:ml-1">{formatter.format(cartItemsData.totalQuantity)}</div>
                                                    </div>
                                                    <div className="sm:flex px-1.5 text-light-400 items-center">
                                                        <h1 className="capitalize font-semibold text-xs sm:text-base">{ t('initial price')}:</h1>
                                                        <div className="font-bold ml-0.5 pt-1 sm:ml-1">{formatter.format(cartItemsData.totalInitialPrice)} €</div>
                                                    </div>
                                                </div> 
                                            </div>
                                            <div className="grid grid-cols-3 gap-1 sm:gap-2 items-center">
                                                <div  onClick={(e) => openTab(e, 'product-list')} className="text-blue-normal bg-white border border-blue-normal px-1 sm:px-2 py-2 rounded-lg w-full text-center capitalize cursor-pointer font-semibold text-[11px] sm:text-base">
                                                    { t('add more items')}
                                                </div>
                                                <div>
                                                    <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " text-white px-1 sm:px-2 py-2 border rounded-lg text-center capitalize font-semibold text-[11px] sm:text-base w-full"}>
                                                        { t('cart')}
                                                    </button>
                                                </div>
                                                <div>
                                                    <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-full text-white px-1 sm:px-2 py-2 border rounded-lg text-center capitalize font-semibold text-[11px] sm:text-base"}>
                                                        { t('summary')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {(showTab === 'product-list') &&
                                        <div className="space-y-2">
                                            {(firstLevelCategoryList.length > 0) && <CategoryScrollFilter firstCategoryList={firstLevelCategoryList} secondCategoryList={secondLevelCategoryList} thirdCategoryList={thirdLevelCategoryList} sendSecondLevelCategoryList={handleProductSecondLevelCategoryList} sendThirdLevelCategoryList={handleProductThirdLevelCategoryList} filterSelected={filterInputs} sendFilterDataFromChild={handleFilterDataFromChild} />}
                                            <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-2 sm:space-y-4 shadow-around">
                                                <div className="xl:flex xl:justify-between xl:items-center xl:space-x-2 space-y-2 xl:space-y-0">
                                                    <SearchBar placeholder={t("search")+"..."} term={searchTerm} setSearchDataFromChild={handleCommonSearchDataFromChild}/>
                                                    <div className="sm:flex sm:items-center sm:space-x-2 space-y-2 sm:space-y-0">
                                                        <CategorySubcategoryFilter filterCategoryList={filterCategoryList} filterSelectedData={filterInputs} onSelectionChange={handleSelectionChange} />
                                                        <div className="flex items-center justify-end space-x-2">
                                                            {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                                <div className="relative flex sm:hidden flex-col items-center group">
                                                                    <div className="border border-blue-normal rounded-xl cursor-pointer bg-white py-1.5 px-2">
                                                                        <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                    </div>
                                                                    <FilterDataHover filter={filterInputs} />
                                                                </div>
                                                            : null}
                                                            <div ref={dropdownRef2} className="relative"> 
                                                                <div className="sm:hidden flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e, 'two')}>
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/sort.svg" alt="sort" />
                                                                </div>
                                                                {
                                                                    showSortTwo
                                                                    ?
                                                                        <ul className="z-20 py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-52 text-left h-40 overflow-y-auto no-scrollbar">
                                                                            {sortTypesList.map((value, index) => (
                                                                                <li key={index} onClick={(e) => handleSortTypeTwoDataFromChild((e), value)} className={(sortName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                                                            ))}
                                                                        </ul>
                                                                    : null
                                                                }
                                                            </div>
                                                            <div ref={dropdownRef1} className="relative">
                                                                <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-3 sm:py-2 px-4" onClick={(e) => handleShowFilter(e, 'two')}>
                                                                    <img className="w-4" src="../../../../assets/icons/table/filter.svg" alt="filter" />
                                                                    <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                                                </div>
                                                                {
                                                                    showFilterTwo 
                                                                    ?
                                                                        <FilterFormLayout>
                                                                            <form onSubmit={(e) => handleFilterSubmit(e)}>
                                                                                <div className="px-2 sm:px-4 space-y-2 sm:space-y-4">
                                                                                    <div>
                                                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('product category')}</label>
                                                                                        <div className="inline-block relative w-full mt-1">
                                                                                            <button type="button" onClick={(e) => handleShowCategory(e, 'two')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                                <span className="text-gray-dark capitalize mr-1 text-xs sm:text-sm">{filterInputs.categoryIdArray.length > 0 ? t('filter is applied') : t('select category')}</span>
                                                                                                <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                            </button>
                                                                                            {
                                                                                                showCategoryTwo
                                                                                                ? 
                                                                                                    <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-30 text-background-dark bg-white shadow-md rounded-md">
                                                                                                        <CategoryCheckbox parentData={filterInputs.categoryIdArray} categoryList={categoryListTwo} sendCategoryDataFromChild={handleCategoryDataFromChild}/>
                                                                                                    </ul>                            
                                                                                                : null
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('product group a')}</label>
                                                                                        <div className="inline-block relative w-full mt-1">
                                                                                            <button type="button" onClick={(e) => handleShowProductGroup(e, 'two')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                                <span className="text-gray-dark capitalize mr-1 text-xs sm:text-sm">{filterInputs.productGroupIdArray.length > 0 ? t('filter is applied') : t('select product group')}</span>
                                                                                                <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                            </button>
                                                                                            {
                                                                                                showProductGroupTwo
                                                                                                ? 
                                                                                                    <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-20 text-background-dark bg-white shadow-md rounded-md">
                                                                                                        <ProductGroupCheckbox parentData={filterInputs.productGroupIdArray} productGroupList={productGroupList} sendProductGroupDataFromChild={handleProductGroupDataFromChild}/>
                                                                                                    </ul>                            
                                                                                                : null
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('product code')}</label>
                                                                                        <div className="inline-block relative w-full mt-1">
                                                                                            <input type="text" name="productCode" value={filterInputs.productCode} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("product code")} />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <label className="font-medium capitalize text-sm sm:text-base">{ t('description')}</label>
                                                                                        <div className="inline-block relative w-full mt-1">
                                                                                            <textarea type="text" name="description" value={filterInputs.description} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("description")} >{filterInputs.description}</textarea>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="flex items-center justify-end my-2">
                                                                                        <div>
                                                                                            <button onClick={(e) => clearFilterData(e)} type="button" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                                                        </div>
                                                                                        <div className="ml-4">
                                                                                            <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </form>
                                                                        </FilterFormLayout>
                                                                    : null
                                                                }
                                                            </div>
                                                            {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                                <div className="relative hidden sm:flex flex-col items-center group">
                                                                    <div className="border border-blue-normal rounded-xl cursor-pointer bg-white p-2 ml-2">
                                                                        <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                    </div>
                                                                    <FilterDataHover filter={filterInputs} />
                                                                </div>
                                                            : null}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* table */}
                                                <div className="sm:block hidden mt-4 overflow-x-auto shadow-md rounded-lg">
                                                    <table className="w-full text-xs">
                                                        <thead className="text-gray-normal bg-background-normal">
                                                            <tr>
                                                                <th scope="col" className="font-normal p-4">
                                                                    <div className="flex">
                                                                        <div className="mr-2 uppercase">
                                                                            { t('product name')}
                                                                        </div>
                                                                        <SortData fieldName={'productname'} sortNameData={sortName} sortTypeData={sortType} setSortDataFromChild={handleSortDataFromChild} />
                                                                    </div>
                                                                </th>
                                                                <th scope="col" className="font-normal p-4">
                                                                    <div className="flex">
                                                                        <div className="mr-2 uppercase">
                                                                            { t('price')}
                                                                        </div>
                                                                        <SortData fieldName={'price'} sortNameData={sortName} sortTypeData={sortType} setSortDataFromChild={handleSortDataFromChild} />
                                                                    </div>
                                                                </th>
                                                                <th scope="col" className="font-normal p-4">
                                                                    <div className="flex">
                                                                        <div className="mr-2 uppercase">
                                                                            { t('m/m')}
                                                                        </div>
                                                                        <SortData fieldName={'unit'} sortNameData={sortName} sortTypeData={sortType} setSortDataFromChild={handleSortDataFromChild} />
                                                                    </div>
                                                                </th>
                                                                <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                    { t('add item')}
                                                                </th>
                                                                <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                    { t('message')}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {products.list?.length > 0 && products.list.map((row, index) => (
                                                            <tr key={'product'+index} className="bg-white border-b hover:bg-gray-50">
                                                                <td className="py-4 px-2 font-semibold w-[45%]">
                                                                    <div className="flex">
                                                                        <div className="w-14 lg:w-auto">
                                                                            <img className="w-8 h-8" src={row.b2bline4 ? row.b2bline4 : defaultProductImage} alt="product-img" />
                                                                        </div>
                                                                        <div className="ml-2 grid justify-between">
                                                                            <h1 className="text-base tracking-wider">{row.b2bline1}</h1>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline2}</div>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline3}</div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="py-4 px-2 text-light-400">
                                                                    {formatter.format(row.productprice)} €
                                                                </td>
                                                                <td className="py-4 px-2 text-light-400">
                                                                    {row.baseUnitOfMeasure ? row.baseUnitOfMeasure : 'NA'}
                                                                </td>
                                                                <td className="py-4 px-2 flex w-52 sm:flex-col sm:items-center sm:justify-center lg:flex-row">
                                                                    <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                </td>
                                                                <td className="py-4 px-2 text-light-400">
                                                                    <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                    {isTableLoader ? <TableLoaderIcon />
                                                        : ((products.list?.length > 0) ?
                                                                <Pagination
                                                                    currentPage={rowCurrentPage}
                                                                    totalCount={products.total_record}
                                                                    pageSize={rowsPerPage}
                                                                    perPageCount={products.list.length}
                                                                    onPageChange={page => handleCurrentPage(page)}
                                                                    onPageSizeChange={row => handlePerPage(row)}
                                                                />
                                                            : 
                                                            <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize flex flex-col items-center justify-center">
                                                                <img className="mb-2" src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                                { t('no records available')}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                                                    {(products.list?.length > 0) &&
                                                        <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                                            {products.list.map((row, index) => (
                                                                <div key={'product'+index}>
                                                                    <div className="grid space-y-2">
                                                                        <div className="flex">
                                                                            <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={row.b2bline4 ? row.b2bline4 : defaultProductImage} alt="product" />
                                                                            <div className="ml-2 flex flex-col justify-between w-full">
                                                                                <div>
                                                                                    <div className="font-medium text-xs">{row.b2bline1}</div>
                                                                                    <div className="text-light-400 text-[10px] capitalize">{row.b2bline2}</div>
                                                                                    <div className="text-light-400 text-[10px] capitalize">{row.b2bline3}</div>
                                                                                </div>
                                                                                <div className="text-light-400 text-sm text-right">
                                                                                    <span className="capitalize">{ t('price')} : </span><span className="font-medium">{formatter.format(row.productprice)} €</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex justify-between items-center">
                                                                            <div className="text-light-400 text-xs">
                                                                                <div className="uppercase">{ t('m/m')} : </div><div className="font-medium">{row.baseUnitOfMeasure}</div>
                                                                            </div>
                                                                            <div className="flex">
                                                                                <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                            </div>
                                                                        </div>
                                                                        <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                    </div>
                                                                    <div className="my-3 border-t-2 border-background-normal"></div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    }
                                                    {isTableLoader ? <TableLoaderIcon />: 
                                                        ((products.list?.length > 0) ?
                                                            <MobilePagination
                                                                currentPage={rowCurrentPage}
                                                                totalCount={products.total_record}
                                                                pageSize={rowsPerPage}
                                                                perPageCount={products.list.length}
                                                                onPageChange={page => handleCurrentPage(page)}
                                                                onPageSizeChange={row => handlePerPage(row)}
                                                            />
                                                        : 
                                                            <div className="py-4 text-center font-bold text-xs capitalize flex flex-col items-center justify-center">
                                                                <img className="mb-2" src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                                { t('no records available')}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                <div className="flex justify-between sm:justify-end sm:space-x-2">
                                                    <div>
                                                        <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                            { t('cart')}
                                                        </button>
                                                    </div>
                                                    <div>
                                                        <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                            { t('summary')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {(showTab === 'cart') &&
                                        <div className="space-y-2 sm:space-y-4 relative">
                                            {isCartLoader &&
                                                <div className="absolute w-full h-full bg-blue-100 z-40 opacity-50">
                                                    <CartLoaderIcon /> 
                                                </div>
                                            }
                                            <div className="py-2 sm:py-4 bg-white border border-white rounded-lg shadow-around">
                                                {/* heading */}
                                                <div className="px-2 sm:px-4 lg:flex lg:justify-between items-center">
                                                    <div>
                                                        <h1 className="sm:text-xl font-bold capitalize">{ t('items added')}</h1>
                                                    </div>
                                                    <div className="mt-2 sm:pt-0 text-sm text-light-400 capitalize">
                                                        <div className="grid gap-1 text-xs sm:flex sm:divide-x-2 sm:divide-gray-dark sm:divide-solid sm:justify-end sm:items-center"> 
                                                            <div className="flex sm:grid lg:flex sm:pr-1 text-light-400 items-center">
                                                                <h1 className="capitalize font-semibold">{ t('no. of items')}:</h1>
                                                                <div className="font-bold ml-1">{virtualCartItems.itemsCount}</div>
                                                            </div>
                                                            <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                <h1 className="capitalize font-semibold">{ t('total quantity')}:</h1>
                                                                <div className="font-bold ml-1">{virtualCartItems.totalQuantity ? formatter.format(virtualCartItems.totalQuantity) : formatter.format(0)}</div>
                                                            </div>
                                                            <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                <h1 className="capitalize font-semibold">{ t('net amount')}:</h1>
                                                                <div className="font-bold ml-1">{virtualCartItems.netAmount ? formatter.format(virtualCartItems.netAmount) : formatter.format(0)} €</div>
                                                            </div>
                                                            <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                <h1 className="capitalize font-semibold">{ t('extra taxes')}:</h1>
                                                                <div className="font-bold ml-1">{virtualCartItems.totalTaxes ? formatter.format(virtualCartItems.totalTaxes) : formatter.format(0)} €</div>
                                                            </div>
                                                            <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                <h1 className="capitalize font-semibold">{ t('total')} <span className="uppercase">{ t('vat')}</span>:</h1>
                                                                <div className="font-bold ml-1">{virtualCartItems.vats ? formatter.format(virtualCartItems.vats) : formatter.format(0)} €</div>
                                                            </div>
                                                            <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                <h1 className="capitalize font-semibold">{ t('total amount')}:</h1>
                                                                <div className="font-bold ml-1">{virtualCartItems.totalAmount ? formatter.format(virtualCartItems.totalAmount) : formatter.format(0)} €</div>
                                                            </div>
                                                        </div> 
                                                    </div>
                                                </div>
                                                {/* horizontal line */}
                                                <div className="my-3 border-t border-background-normal"></div>
                                                {/* items table*/}
                                                { inputs.items.length > 0 
                                                    ?
                                                        <>
                                                            <div className="relative overflow-x-auto sm:block hidden">
                                                                <table className="w-full text-xs">
                                                                    <thead className="text-gray-normal">
                                                                        <tr>
                                                                            <th scope="col" className="font-normal uppercase px-2 py-3 w-[25%] text-left">
                                                                                { t('product name')}
                                                                            </th>
                                                                            <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                { t('quantity')}
                                                                            </th>
                                                                            <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                { t('initial price')}
                                                                            </th>
                                                                            <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                { t('net amount') }
                                                                            </th>
                                                                            <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                { t('extra taxes') }
                                                                            </th>
                                                                            <th scope="col" className="font-normal uppercase px-2 py-3 text-center w-[8%]">
                                                                                { t('vat') }
                                                                            </th>
                                                                            <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                { t('total amount')}
                                                                            </th>
                                                                            <th scope="col" className="font-normal uppercase px-2 py-3 text-left w-52">
                                                                                { t('add') }/{ t('remove') }
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {inputs.filteredItems.map((item, key) => (
                                                                            <React.Fragment key={'items' + item.product.item_code}>
                                                                                <tr className={(inputs.filteredItems.length !== key+1 ? 'border-b border-dashed' : '') +" bg-white hover:bg-gray-50 text-[11px]"}>
                                                                                    <td className="p-3 font-semibold">
                                                                                        <div className="flex space-x-2">
                                                                                            <img className="w-8 h-8" src={item.product.b2bline4 ? item.product.b2bline4 : defaultProductImage} alt="product-img" />
                                                                                            <div className="grid justify-between">
                                                                                                <h1>{item.product.productname}</h1>
                                                                                                <p className="text-light-400 text-[10px] capitalize">
                                                                                                    {t('product code')}: {item.product.item_code}
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="p-3 text-light-400 text-center">{item.quantity ? formatter.format(item.quantity) : formatter.format(0)}</td>
                                                                                    <td className="p-3 text-light-400 text-center">{formatter.format(item.product.productprice)} €</td>
                                                                                    <td className="p-3 text-light-400 text-center">
                                                                                        {item.quantity ? formatter.format(parseFloat((item.product.productprice * item.quantity).toFixed(2))) : formatter.format(0)} €
                                                                                    </td>
                                                                                    <td className="p-3 text-light-400 text-center">
                                                                                        {item.quantity ? formatter.format(item.quantity * item.product.extra_taxes) : formatter.format(0)} €
                                                                                    </td>
                                                                                    <td className="p-3 text-light-400 text-center">
                                                                                        {item.quantity ? formatter.format(parseFloat((item.quantity * Number(item.product.vaT_Value)).toFixed(2))) : formatter.format(0)} €
                                                                                    </td>
                                                                                    <td className="p-3 text-light-400 text-center">
                                                                                        {item.quantity ? formatter.format(
                                                                                            parseFloat((item.product.productprice * item.quantity).toFixed(2)) + 
                                                                                            parseFloat(((item.quantity) * Number(item.product.vaT_Value)).toFixed(2)) +
                                                                                            parseFloat((item.product.extra_taxes * item.quantity)) 
                                                                                        ) : formatter.format(0)} €
                                                                                    </td>
                                                                                    <td className="p-3 w-52 flex sm:flex-col sm:items-center sm:justify-start lg:flex-row">
                                                                                        <RemoveQuantityButton row={item.product} staticQuantityArray={productStaticQuantity[item.product.item_code]} sendQuantityDataFromChild={handleQuantityDataFromChild} />
                                                                                    </td>
                                                                                </tr>
                                                                                
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3 p-2 sm:p-4">
                                                                {(inputs.filteredItems.length > 0) ?
                                                                    <div className="space-y-3">
                                                                        {inputs.filteredItems.map((item, key) => (
                                                                            <div key={'items' + item.product.item_code}>
                                                                                <div className="grid space-y-2 bg-white border border-gray-200 rounded-lg p-3">
                                                                                    <div className="flex">
                                                                                        <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" 
                                                                                            src={item.product.image ? item.product.image : defaultProductImage} 
                                                                                            alt="product" />
                                                                                        <div className="ml-3 flex flex-col justify-between w-full">
                                                                                            <div>
                                                                                                <div className="font-medium text-xs">{item.product.productname}</div>
                                                                                                <div className="text-light-400 text-[10px] capitalize">{t('product code')}: {item.product.item_code}</div>
                                                                                            </div>
                                                                                            <div className="flex text-[10px] justify-between">
                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                    <h1 className="capitalize font-medium">{t('initial price')}:</h1>
                                                                                                    <div className="font-bold ml-1 sm:ml-2">{formatter.format(item.product.productprice)} €</div>
                                                                                                </div>
                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                    <h1 className="capitalize font-medium">{t('quantity')}:</h1>
                                                                                                    <div className="font-bold ml-1 sm:ml-2">{item.quantity ? formatter.format(item.quantity) : formatter.format(0)}</div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="flex text-[10px] justify-between">
                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                    <h1 className="capitalize font-medium">{t('net amount')}:</h1>
                                                                                                    <div className="font-bold ml-1 sm:ml-2">{item.quantity ? formatter.format(parseFloat((item.product.productprice * item.quantity).toFixed(2))) : formatter.format(0)} €</div>
                                                                                                </div>
                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                    <h1 className="uppercase font-medium">{t('vat')}:</h1>
                                                                                                    <div className="font-bold ml-1 sm:ml-2">{item.quantity ? formatter.format(parseFloat(((item.quantity) * Number(item.product.vaT_Value)).toFixed(2))) : formatter.format(0)} €</div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="flex text-[10px] justify-between">
                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                    <h1 className="capitalize font-medium">{t('extra taxes')}:</h1>
                                                                                                    <div className="font-bold ml-1 sm:ml-2">{item.quantity ? formatter.format(item.quantity * item.product.extra_taxes) : formatter.format(0)} €</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="flex justify-between items-center">
                                                                                        <div>
                                                                                            <div className="capitalize text-xs font-medium">{t('total amount')}:</div>
                                                                                            <div className="font-bold text-sm">
                                                                                                {item.quantity ? formatter.format(parseFloat((item.product.productprice * item.quantity).toFixed(2)) + parseFloat(((item.quantity) * Number(item.product.vaT_Value)).toFixed(2)) + parseFloat((item.product.extra_taxes * item.quantity)) ) : formatter.format(0)} €
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="flex">
                                                                                            <RemoveQuantityButton row={item.product} staticQuantityArray={productStaticQuantity[item.product.item_code]} sendQuantityDataFromChild={handleQuantityDataFromChild} />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="my-3 border-t-2 border-background-normal"></div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    : null
                                                                }
                                                            </div>
                                                        </>
                                                    : 
                                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                                            { t('not added yet')}
                                                        </div>
                                                }
                                            </div>
                                            { isCalculate
                                                ?
                                                    <div className="p-2 sm:p-4 bg-white border shadow-around border-white rounded-lg grid lg:grid-cols-2 space-y-2 xl:space-y-0">
                                                        <label className="block sm:hidden font-semibold text-sm capitalize">{ t('coupon code') }:</label>
                                                        <div className="flex w-full justify-between sm:justify-normal items-center sm:space-x-3 text-sm sm:text-base">
                                                            <label className="hidden sm:block font-semibold capitalize">{ t('coupon code') }:</label>
                                                            <input type="text" name="couponCode" value={inputs.couponCode} onChange={(e) => handleCouponCodeChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-md p-2 placeholder:capitalize" placeholder={ t("coupon code")} />
                                                            <button type="button" onClick={(e) => handleApplyCouponCode(e)} className="capitalize font-semibold bg-black-300 text-blue-normal py-2 px-2 sm:px-4 rounded-lg">{ t('apply')}</button>
                                                        </div>
                                                        <div className="flex justify-between lg:justify-end space-x-2 items-center">
                                                            <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " sm:w-24 text-white p-2 border rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                                { t('summary')}
                                                            </button>
                                                            {!showCalculating 
                                                                ?
                                                                <button type="button" onClick={(e) => calculateItemsAmount(e)} className="cursor-pointer bg-blue-normal border-blue-normal capitalize text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide w-fit">{!reCalculate ? t('calculate final amount') : t('re-calculate final amount')}</button>
                                                                :
                                                                <button type="button" className="cursor-wait bg-blue-normal border-blue-normal capitalize text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide w-fit">{ t('calculating') }...</button>
                                                            }
                                                        </div>
                                                    </div>
                                                : 
                                                    <div className="text-right">
                                                        <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " sm:w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                            { t('summary')}
                                                        </button>
                                                    </div>
                                            }
                                        </div>
                                    }
                                    {(showTab === 'summary') &&
                                        <form onSubmit={handleSubmit} autoComplete="off">
                                            <div className="space-y-2 sm:space-y-4">
                                                <div className={"lg:grid-cols-3 p-2 sm:p-4 bg-white shadow-around border border-white rounded-lg grid text-xs sm:text-sm space-y-2 sm:space-y-0 gap-2"}>
                                                    <div className="flex items-center w-full">
                                                        <div className="text-light-700 font-semibold capitalize mr-2 sm:w-fit">{ t('payment method')}:</div>
                                                        <div ref={dropdownRef} className="w-auto relative">
                                                            <div onClick={(e) => openPaymentMethod(e)}>
                                                                <button className="bg-background-normal justify-between font-normal text-base px-3 py-2 rounded-md inline-flex items-center w-full">
                                                                    <span className={((paymentMethod && paymentMethod.length > 0) ? "text-black" : "text-gray-dark") + " mr-6 text-xs sm:text-sm"}>{(paymentMethod && paymentMethod.length > 0) ? paymentMethod : t('select payment method')}</span>
                                                                    <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                </button>
                                                            </div>
                                                            {
                                                                showPaymentMethod
                                                                ? 
                                                                    <ul className={(paymentMethods.length > 4 ? "min-h-auto max-h-40" : "" ) + " absolute z-10 text-background-dark bg-white shadow-md rounded-md w-full overflow-y-auto no-scrollbar"}>
                                                                        { paymentMethods.length > 0 ?
                                                                            paymentMethods.map((method, index) => (
                                                                                <li key={index} onClick={(e) => handlePaymentMethod((e), method)} className="bg-white hover:bg-action-hover cursor-pointer py-1.5 px-3 block whitespace-no-wrap capitalize text-xs sm:text-sm">{method.name}</li>
                                                                            ))
                                                                            : null
                                                                        }
                                                                    </ul>                            
                                                                : null
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center">
                                                        <div className="text-light-700 font-semibold capitalize mr-2 md:w-32">{ t('agreement day')}:</div>
                                                        <div className="text-xs">{workingDaysString}</div>
                                                    </div>
                                                    <div className="flex lg:justify-end xl:justify-center items-center">
                                                        <div className="text-light-700 font-semibold capitalize mr-2">{ t('delivery day')}:</div>
                                                        <DateInputField setDataFromChild={handleDateDataFromChild} startDate={currentDate} dateInput={deliveryDate} disableDate={true} week={disbaleWeeks}/>
                                                    </div>
                                                </div>
                                                
                                                <div className="grid sm:grid-cols-2 gap-2 sm:space-x-2">
                                                    <div className="p-2 sm:p-4 bg-white border shadow-around border-white rounded-lg text-xs sm:text-base h-fit">
                                                    <div className="space-y-2">
                                                        <div className="font-semibold capitalize w-fit">{ t('comments')}</div>
                                                        <textarea name="comment" rows="7" columns="10" value={comment} onChange={(e) => handleCommentChange(e)} className="w-full border-background-normal focus:outline-none bg-background-normal rounded-lg p-2 placeholder:capitalize" placeholder={ t("write comments here...")} >{comment}</textarea>
                                                    </div>
                                                </div>
                                                    <div className="py-2 sm:py-4 bg-white border shadow-around border-white rounded-lg">
                                                        {/* heading */}
                                                        <div className="px-2 sm:px-4">
                                                            <h1 className="sm:text-lg font-semibold capitalize">{ t('final order summary')}</h1>
                                                        </div>
                                                        {/* horizontal line */}
                                                        <div className="my-3 border-t border-background-normal"></div>
                                                        {/* order summary */}
                                                        <div className="px-2 sm:px-4 text-right space-y-3.5">
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                                                <div className="font-bold text-sm">{finalCartItems.itemsCount}</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.totalQuantity)}</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('discount value')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(totalDiscountAmount)}</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total net value')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.netAmount)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('extra taxes')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.totalTaxes)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total')} <span className="uppercase">{ t('vat')}</span></div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.vats)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total amount')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.totalAmount)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('transportation fee')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.transportationFee)} €</div>
                                                            </div>
                                                            <div className="my-3 border-t border-background-normal"></div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="font-semibold first-letter:capitalize">{ t('amount to be paid')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.totalAmount + shippingCost)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-xs font-normal capitalize">{ t('coupon code')}:</div>
                                                                <div className="font-bold text-xs">{inputs.couponCode ? inputs.couponCode : '--'}</div>
                                                            </div>
                                                            { !formButton 
                                                                ?
                                                                    <button type={(Object.keys(validateValues(inputs)).length === 0 && deliveryDate.length > 0 && paymentMethod && calculateButton) ? "submit" : "button"} className={((Object.keys(validateValues(inputs)).length === 0 && deliveryDate.length > 0 && paymentMethod && calculateButton)? "cursor-pointer bg-blue-normal border-blue-normal" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide capitalize"}>{ t('finalization')}</button>
                                                                :
                                                                    <button type="button" className="cursor-wait bg-blue-normal border-blue-normal capitalize text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide ">{ t('Please wait, in-progress') }</button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    }
                                </div>
                            </div>
                    }
                </div>
            </Layout>
        </div>
    )
}

export default OrderAgain;